export default {
  en: {
    cashier: 'Cashier',
    paymentLogo: 'Payment Logo',
    methodName: 'Method Name',
    pgState: 'PG State',
    platformState: 'Platform State',
    allowedActivities: 'Allowed Activities',
    supportedCountries: 'Supported Countries',
    depositSupportedCurrencies: 'Deposit Supported Currencies',
    withdrawalSupportedCurrencies: 'Withdrawal Supported Currencies',
    showForTags: 'Show For Tags',
    hideForTags: 'Hide For Tags',
    depositProcessingPeriod: 'Deposit Processing Period',
    withdrawalProcessingPeriod: 'Withdrawal Processing Period',
    processingPeriod: 'Processing Period',
    info: 'Info',
    showInfoForDeposit: 'Show Info for Deposit',
    showInfoForWithdrawal: 'Show Info for Withdrawal',
    processingRange: 'Processing Range',
    categoryName: 'Category Name',
    lCategory: 'category',
    translationKeyInfo: 'Make sure to add translations for the key, so that language-specific names are displayed on the website',
    deleteCategoryInfo: 'All the payment methods of the category will be moved to Other system category',
    cashierDeposit: 'Cashier Deposit',
    cashierWithdrawal: 'Cashier Withdrawal',
    depositState: 'Deposit State',
    withdrawalState: 'Withdrawal State',
    generalComponentsInfo: 'General Components are marked with',
    lSymbol: 'symbol',
    resetTranslationsInfo: 'Resetting will remove all custom translations in the current section.',
    exportTranslationInfo: 'Translation keys will be included',
    defaultTranslation: 'Default Translation',
    defaultTranslationInfo: 'Translations in this column will be applied when custom translation gets removed',
    addHintLanguage: 'Add Hint Language',
    selectHintsLanguage: 'Select Hints Language',
    deleteHintLanguage: 'Delete Hint Language',
    section: 'Section',
    chooseLanguage: 'Choose Language',
    availableTranslationsBySections: 'Available Translations by Sections',
    key: 'Key',
    availableTranslations: 'Available Translations',
    createFolder: 'Create Folder',
    moveTo: 'Move to',
    makeSureFileIsNotUsedInfo: 'Make sure this file is not used anywhere.',
    makeSureFilesAreNotUsedInfo: 'Make sure these files are not used anywhere.',
    folderName: 'Folder Name',
    filesUrlsChangedInfo: 'Files URLs will get changed.',
    searchFolder: 'Search Folder',
    move: 'Move',
    folders: 'Folders',
    rename: 'Rename',
    folderFilesDeletedInfo: 'Files in the folder will also be deleted.',
    totalSize: 'Total Size',
    contains: 'Contains',
    file: 'File',
    lFile: 'file',
    lFiles: 'files',
    theFile: 'The file',
    files: 'Files',
    lFolder: 'folder',
    folder: 'Folder',
    lFolders: 'folders',
    fileName: 'File Name',
    dropHereOrUseUploadButton: '<0>Drop files here</0><1> or use the Upload button.</1>',
    copyUrl: 'Copy URL',
    extension: 'Extension',
    size: 'Size',
    dimensions: 'Dimensions',
    url: 'URL',
    droppedFileInfo: 'Dropped files will be immediatly uploaded to this folder',
    theTranslation: 'The translation',
    lSection: 'section',
    thePaymentMethod: 'The payment method',
    theCategory: 'The category',
    cashierSettings: 'Cashier settings',
    fileOrFiles: 'File(s)',
    showingUpdates: 'Showing updates on the website can take up to 30 seconds.',
    inputLanguageKeyHere: '{{languageName}}: Input here',
    subCategory: 'Sub - Category',
    themes: 'Themes',
    systemState: 'System State',
    maintenanceState: 'Maintenance State',
    maintenanceDates: 'Maintenance Dates',
    newTill: 'New Till',
    fixedTill: 'Fixed Till',
    promoTill: 'Promo Till',
    dateTill: 'Date Till',
    newGame: 'New Game',
    fixedGame: 'Fixed Game',
    promoGame: 'Promo Game',
    minLimit: 'Min Limit',
    maxLimit: 'Max Limit',
    isCustom: 'Is Custom',
    standard: 'Standard',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    background: 'Background',
    maintenanceDate: 'Maintenance Date',
    lGame: 'game',
    infinity: 'Infinity',
    new: 'New',
    isNew: 'Is New',
    fixed: 'Fixed',
    isFixed: 'Is Fixed',
    promo: 'Promo',
    isPromo: 'Is Promo',
    gameSettings: 'Game Settings',
    maintenance: 'Maintenance',
    gameGroup: 'Game Group',
    orderBy: 'Order By',
    createGroup: 'Create a Group',
    lGroup: 'group',
    set: 'Set',
    groupType: 'Group Type',
    uploadListInfo: 'You can upload lists with game IDs. Only CSV format is acceptable',
    thePaymentMethods: 'The payment methods',
    gridType: 'Grid Type',
    providersPositioning: 'Providers Positioning',
    groups: 'Groups',
    gameDetailsPreviewInfo: 'The game details are shown on the website with previewing',
    gameDetailsCardInfo: 'The game details are shown on the website with Card Footer',
    providerGamesCount: 'Provider Games Count',
    secondaryOrdering: 'Secondary Ordering',
    advancedView: 'Advanced View',
    lobbyProviders: 'Lobby Providers',
    providerOrder: 'Provider Order',
    gameOrder: 'Game Order',
    secondaryOrderingNote: 'Secondary Game Ordering works when  the config is active and only one  provider is selected, in any other case group specific ordering is applied.',
    providerOrderingNote: 'By default or when unchecked, provider alphabetic order is set. When checked, custom set order is applied',
    searchId: 'Search ID',
    uploadGames: 'Upload Games',
    providerOrdering: 'Provider Ordering',
    pageCap: 'Page Cap',
    playerSpecificGamesAllowed: 'Player Specific Games Allowed',
    loggedInOnly: 'Logged In Only',
    visibleInMyCasino: 'Visible in My Casino',
    visibleOnGameView: 'Visible on Game View',
    visibleOnTheLeftBarMenu: 'Visible on the Left Bar Menu',
    visibleOnMultiGameMenu: 'Visible on Multigame Menu',
    visibleOnNavigation: 'Visible on Navigation',
    visibleOnGroupList: 'Visible on Group List',
    myCasino: 'My Casino',
    gameView: 'Game View',
    leftBarMenu: 'Left Bar Menu',
    multiGameMenu: 'Multigame Menu',
    navigation: 'Navigation',
    lobbies: 'Lobbies',
    visibleOn: 'Visible On',
    optional: 'Optional',
    lobbyWidgetsJackpotInfo: 'Please note, only available for EGT jackpot feed',
    gameStatus: 'Game Status',
    gamesInfoNote: 'Games Information Note',
    gamesInfoNoteHint: 'Games info note button gets available on the website',
    providerId: 'Provider ID',
    gameBackground: 'Game Background',
    gameBackgroundHint: 'If enabled, games background images get available on the website, when launching from the lobbies',
    myCasinoHint: 'If enabled, the "My Casino" sub-section gets available on website mobile view',
    media: 'Media',
    mobilePageCap: 'Page Cap for Mobile Apps',
    lGames: 'games',
    lGameType: 'game type',
    typeName: 'Type Name',
    gameVerticalType: 'Game Vertical Type',
    haveAssignedType: 'Have Assigned Type',
    createGameType: 'Create Game Type',
    jackpotAmountOnHoverInfo: 'The jackpot amount is displayed when the user hovers over a game thumbnail in the lobby',
    jackpotAmountOnThumbnailInfo: 'The jackpot amount is displayed within the game thumbnail frame',
    visibleInGamesSeoPage: "Visible in Games' SEO page",
    providerViewingType: 'Provider Viewing Type',
    providerLogo: 'Provider Logo',
    widgetIcon: 'Widget Icon',
    widgetContentType: 'Content Type',
    desktopBackground: 'Desktop Background',
    mobileBackground: 'Mobile Background',
    gameMainSettings: 'Game Main Settings',
    imageGridType: 'Image Grid Type',
    small: 'Small',
    row: 'Row',
    gameCap: 'Game Cap',
    gameSelection: 'Game Selection',
    lobbyHome: 'Lobby Home',
    lobbyHomeHint: 'Specifies the availability of a static Widget-Base "Lobby Home" Page for the lobby.',
    navigationBar: 'Navigation Bar',
    navigationBarHint: 'Specifies the availability of a Navigation Bar for both Main Lobby and "Lobby Home" pages.',
    isSmallImageSizeInfo: 'In case Small is selected,  image sizes are changed to smaller sizes on the Website.',
    widgetVisibilityInfo: 'The Widget will be visible to logged in players only',
    wins: 'Wins',
    winType: 'Win Type',
    groupSelection: 'Group Selection',
    viewingType: 'Viewing Type',
    group: 'Group',
    items: 'Items',
    groupViewingType: 'Group Viewing Type',
    uploadProviderInfo: 'You can upload provider list. Only CSV format is acceptable',
    randomGamesWidgetInfo: 'The selected Games will be saved and randomized for the widget.',
    widgetImage: 'Widget Image',
    widgetBackground: 'Widget Background',
    desktopImage: 'Desktop Image',
    mobileImage: 'Mobile Image',
    providerAndGamesSelection: 'Provider And Games Selection',
    searchPopup: 'Search Pop-up',
    visibleInSearchPopUp: 'Visible on Search Pop-up',
    jackpotSet: 'Jackpot Set',
    gameUpload: 'Game Upload',
    parallaxInfo: 'In case the parallax solution is activated the four media should be activated',
    parallax: 'Parallax',
    manageCollection: 'Manage Collection',
    cap: 'Cap',
    uploadImage: 'Upload Image',
    viewImage: 'View Image',
    image: 'Image',
    gameDetailsOnHover: 'Game Details on Hover',
    gameDetailsOnHoverInfo: 'Allows to configure the game info to be shown on the hover',
    bannerSet: 'Banner Set',
    storySet: 'Story Set',
    depositButtonOnGames: 'Deposit Button On Games',
    depositButtonOnGamesHint: 'When activated the games on Mobile view will have Deposit Button. In case  the games have Demo version the Demo Button will be hidden by default',
    manageMobileWidgets: 'Manage Mobile Widgets',
    manageDesktopWidgets: 'Manage Desktop Widgets',
    mobileOrder: 'Mobile Order',
    desktopOrder: 'Desktop Order',
    gameWidgetGameCountInfo: 'Only first {{count}} active games will be included in the widget',
    gameGroupSegmentGamesInfo: 'Changes in the game segment will not affect on already created entity',
    gameGroupGameCountInfo: 'Only first {{count}} active games will be included in the group',
    demoButtonOnGames: 'Demo Button on Games',
    demoButtonOnGamesInfo: 'The Demo button appears only if both Demo Launch and Demo Button settings are enabled for the device',
    groupList: 'Group List',
    groupListNote: 'In case the setting is active the group will be visible on the website',
    zingBrainInfo: 'Provides games recommended by ZingBrain',
    recommendationType: 'Recommendation Type',
    dynamicOrder: 'Dynamic Order',
    countdownWidget: 'Countdown Widget',
    pinWidget: 'Pin Widget',
    systemGameGroup: 'System Game Group',
    addToSystemGroup: 'Add to System Group',
    gameEndPopupSettings: 'Game End Popup Settings',
    gameEndPopup: 'Game End Popup',
    filterSettings: 'Filter Settings',
    manageTags: 'Manage Tags',
    winMinimumThreshold: 'Win Minimum Threshold',
    highlightedWins: 'Highlighted Wins',
    widgetType: 'Widget Type',
    playerTargeting: 'Player Targeting',
    segmentConditionDesc: 'Checks the segments players are parts of',
    tagConditionDesc: 'Checks the tags assigned to players',
    in: 'In',
    notIn: 'Not In',
    showInSimilarGame: 'Show in Similar Games Widget',
    showInSimilarGamesInfo: 'When active, the group\'s games are shown in the Similar Games widget on the SEO Info Page, and in the game-end pop-up when it is enabled',
  },
  es: {
    cashier: 'Cajero',
    paymentLogo: 'Logo de pago',
    methodName: 'Nombre de método',
    pgState: 'Estado PG',
    platformState: 'Estado de la plataforma',
    allowedActivities: 'Actividades permitidas',
    supportedCountries: 'Países admitidos',
    depositSupportedCurrencies: 'Monedas admitidas para el depósito',
    withdrawalSupportedCurrencies: 'Monedas admitidas para la retirada',
    showForTags: 'Mostrar por etiquetas',
    hideForTags: 'Ocultar por etiquetas',
    depositProcessingPeriod: 'Periodo de procesamiento de depósitos',
    withdrawalProcessingPeriod: 'Periodo de procesamiento de retiradas',
    processingPeriod: 'Periodo de procesamiento',
    info: 'Información',
    showInfoForDeposit: 'Mostrar información del depósito',
    showInfoForWithdrawal: 'Mostrar información de la retirada',
    processingRange: 'Rango de procesamiento',
    categoryName: 'Nombre de categoría',
    lCategory: 'categoría',
    translationKeyInfo: 'Asegúrese de añadir traducciones para la clave de modo que los nombres específicos de cada idioma se muestren en la página web',
    deleteCategoryInfo: 'Todos los métodos de pago de la categoría se trasladarán a la categoría Otro sistema',
    cashierDeposit: 'Depósito cajero',
    cashierWithdrawal: 'Retirada cajero',
    depositState: 'Estado depósito',
    withdrawalState: 'Estado retirada',
    generalComponentsInfo: 'Los componentes generales están marcados con',
    lSymbol: 'símbolo',
    resetTranslationsInfo: 'Reiniciar eliminará todas las traducciones personalizadas de la sección actual.',
    exportTranslationInfo: 'Se incluirán las traducciones de clave',
    defaultTranslation: 'Traducción predeterminada',
    defaultTranslationInfo: 'Las traducciones de esta columna se aplicarán cuando se elimine la traducción personalizada',
    addHintLanguage: 'Añadir idioma de las sugerencias',
    selectHintsLanguage: 'Seleccionar idioma de las sugerencias',
    deleteHintLanguage: 'Eliminar idioma de las sugerencias',
    section: 'Sección',
    chooseLanguage: 'Seleccionar idioma',
    availableTranslationsBySections: 'Traducciones disponibles por secciones',
    key: 'Clave',
    availableTranslations: 'Traducciones disponibles',
    createFolder: 'Crear carpeta',
    moveTo: 'Mover a',
    makeSureFileIsNotUsedInfo: 'Asegúrese de que este archivo no se utiliza en ningún sitio.',
    makeSureFilesAreNotUsedInfo: 'Asegúrese de que estos archivos no se utilizan en ningún sitio.',
    folderName: 'Nombre de la carpeta',
    filesUrlsChangedInfo: 'Las URL de los archivos se cambiarán.',
    searchFolder: 'Buscar Carpeta',
    move: 'Mover',
    folders: 'Carpetas',
    rename: 'Renombrar',
    folderFilesDeletedInfo: 'Los archivos de la carpeta también se eliminarán.',
    totalSize: 'Tamaño total',
    contains: 'Contiene',
    file: 'Archivo',
    lFile: 'archivo',
    lFiles: 'archivos',
    theFile: 'El archivo',
    files: 'Archivos',
    lFolder: 'carpeta',
    folder: 'Carpeta',
    lFolders: 'carpetas',
    fileName: 'Nombre de archivo',
    dropHereOrUseUploadButton: '<0>Arrastre aquí los archivos</0><1>o utilice el botón Subir.</1>',
    copyUrl: 'Copiar URL',
    extension: 'Extensión',
    size: 'Tamaño',
    dimensions: 'Dimensiones',
    url: 'URL',
    droppedFileInfo: 'Los archivos enviados se cargarán inmediatamente en esta carpeta',
    theTranslation: 'La traducción',
    lSection: 'sección',
    thePaymentMethod: 'El método de pago',
    theCategory: 'La categoría',
    cashierSettings: 'Opciones de cajero',
    fileOrFiles: 'Archivo(s)',
    showingUpdates: 'Mostrar las actualizaciones en el sitio web puede tardar hasta 30 segundos.',
    inputLanguageKeyHere: '{{languageName}}: Introduzca aquí',
    subCategory: 'Subcategoría',
    themes: 'Temas',
    systemState: 'Estado del sistema',
    maintenanceState: 'Estado del mantenimiento',
    maintenanceDates: 'Fechas del mantenimiento',
    newTill: 'Caja nueva',
    fixedTill: 'Caja fija',
    promoTill: 'Caja promocional',
    dateTill: 'Caja fecha',
    newGame: 'Juego nuevo',
    fixedGame: 'Juego fijo',
    promoGame: 'Juego promocional',
    minLimit: 'Límite mín.',
    maxLimit: 'Límite máx.',
    isCustom: 'Es personalizado',
    standard: 'Estándar',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    background: 'Fondo',
    maintenanceDate: 'Fecha de mantenimiento',
    lGame: 'juego',
    infinity: 'Infinito',
    new: 'Nuevo',
    isNew: 'Es nuevo',
    fixed: 'Fijo',
    isFixed: 'Es fijo',
    promo: 'Promo',
    isPromo: 'Es promo',
    gameSettings: 'Opciones de juego',
    maintenance: 'Opciones de juego',
    gameGroup: 'Grupo de Juego',
    orderBy: 'Ordenar por',
    createGroup: 'Crear un Grupo',
    lGroup: 'grupo',
    set: 'Seta',
    groupType: 'Tipo de Grupo',
    uploadListInfo: 'Puede cargar listas con ID de juegos. Sólo se acepta el formato CSV',
    thePaymentMethods: 'El Método de Pago',
    gridType: 'Tipo de Agarre',
    providersPositioning: 'Proveedores Posicionamiento',
    groups: 'Grupos',
    gameDetailsPreviewInfo: 'Los detalles del juego se muestran en el sitio web con vista previa',
    gameDetailsCardInfo: 'Los detalles del juego se muestran en el sitio web con el Card Footer',
    providerGamesCount: 'Recuento de Juegos de Proveedores',
    secondaryOrdering: 'Pedidos Secundarios',
    advancedView: 'Vista Avanzada',
    lobbyProviders: 'Proveedores de Lobby',
    providerOrder: 'Orden del Proveedor',
    gameOrder: 'Orden del Juego',
    secondaryOrderingNote:
      'El ordenamiento secundario de juegos funciona cuando la configuración está activa y solo se selecciona un proveedor; en cualquier otro caso, se aplica un ordenamiento específico por grupo.',
    providerOrderingNote: 'Por defecto o cuando no está marcado, se establece el orden alfabético del proveedor. Cuando está marcado, se aplica el orden personalizado establecido.',
    searchId: 'Buscar ID',
    uploadGames: 'Subir juegos',
    providerOrdering: 'Ordenamiento de Proveedores',
    pageCap: 'Límite de Páginas',
    playerSpecificGamesAllowed: 'Juegos Permitidos para Jugadores Específicos',
    loggedInOnly: 'Solo para sesiones iniciadas',
    visibleInMyCasino: 'Visible en Mi Casino',
    visibleOnGameView: 'Visible en la Vista del Juego',
    visibleOnTheLeftBarMenu: 'Visible en el Menú de la Barra Izquierda',
    visibleOnMultiGameMenu: 'Visible en el Menú de Multijuegos',
    visibleOnNavigation: 'Visible en la Navegación',
    myCasino: 'Mi Casino',
    gameView: 'Vista del Juego',
    leftBarMenu: 'Menú de la Barra Izquierda',
    multiGameMenu: 'Menú Multijuegos',
    navigation: 'Navegación',
    lobbies: 'Salas de Espera',
    visibleOn: 'Visible en',
    optional: 'Opcional',
    lobbyWidgetsJackpotInfo: 'Por favor, ten en cuenta que solo está disponible para el feed de jackpot de EGT.',
    gameStatus: 'Estado del Juego',
    gamesInfoNote: 'Nota de Información de Juegos',
    gamesInfoNoteHint: 'El botón de la nota informativa de juegos está disponible en el sitio web',
    providerId: 'ID del Proveedor',
    gameBackground: 'Antecedentes del Juego',
    gameBackgroundHint: 'Si está habilitado, las imágenes de fondo de los juegos estarán disponibles en el sitio web al iniciarlos desde el Inicio',
    myCasinoHint: 'Si está habilitado, la subsección "Mi Casino" estará disponible en la vista móvil del sitio web.',
    media: 'Media',
    mobilePageCap: 'Tope de Páginas para Apps Móviles',
    lGames: 'juegos',
    lGameType: 'Tipo de Juego',
    typeName: 'Tipo de Nombre',
    gameVerticalType: 'Tipo Vertical de Juego',
    haveAssignedType: 'Tipo Asignado',
    createGameType: 'Crear Tipo de Juego',
    jackpotAmountOnHoverInfo: 'El monto del jackpot se muestra cuando el usuario pasa el cursor sobre la miniatura del juego en el lobby',
    jackpotAmountOnThumbnailInfo: 'El monto del jackpot se muestra dentro del marco de la miniatura del juego',
    visibleInGamesSeoPage: 'Visible en la página SEO de juegos',
    providerViewingType: 'Tipo de visualización del proveedor',
    providerLogo: 'Logo del proveedor',
    widgetIcon: 'Ícono del widget',
    widgetContentType: 'Tipo de contenido',
    desktopBackground: 'Fondo para escritorio',
    mobileBackground: 'Fondo para móvil',
    gameMainSettings: 'Configuración principal del juego',
    imageGridType: 'Tipo de cuadrícula de imágenes',
    small: 'Pequeña',
    row: 'Fila',
    gameCap: 'Límite de juegos',
    gameSelection: 'Selección de juegos',
    lobbyHome: 'Página principal del lobby',
    lobbyHomeHint: 'Especifica la disponibilidad de una página estática basada en widget llamada "Página principal del lobby".',
    navigationBar: 'Barra de navegación',
    navigationBarHint: 'Especifica la disponibilidad de una barra de navegación para la página principal del lobby y la "Página principal del lobby".',
    isSmallImageSizeInfo: 'Si se selecciona Pequeña, los tamaños de imagen se ajustan a tamaños más pequeños en el sitio web.\nEl widget será visible solo para jugadores con sesión iniciada.',
    widgetVisibilityInfo: 'El widget será visible solo para jugadores con sesión iniciada.',
    wins: 'Ganancias',
    winType: 'Tipo de ganancia',
    groupSelection: 'Selección de grupo',
    viewingType: 'Tipo de visualización',
    group: 'Grupo',
    items: 'Elementos',
    groupViewingType: 'Tipo de visualización de grupo',
    uploadProviderInfo: 'Puedes subir la lista de proveedores. Solo se acepta formato CSV.',
    randomGamesWidgetInfo: 'Los juegos seleccionados se guardarán y mostrarán de forma aleatoria en el widget.',
    widgetImage: 'Imagen del widget',
    widgetBackground: 'Fondo del widget',
    desktopImage: 'Imagen para escritorio',
    mobileImage: 'Imagen para móvil',
    providerAndGamesSelection: 'Selección de proveedores y juegos',
    searchPopup: 'Búsqueda emergente',
    visibleInSearchPopUp: 'Visible en la búsqueda emergente',
    jackpotSet: 'Conjunto de jackpot',
    gameUpload: 'Carga de juegos',
    parallaxInfo: 'Si la solución parallax está activada, los cuatro medios deben estar activos.',
    parallax: 'Parallax',
    manageCollection: 'Gestionar colección',
    cap: 'Límite',
    uploadImage: 'Subir imagen',
    viewImage: 'Ver imagen',
    image: 'Imagen',
    gameDetailsOnHover: 'Detalles del juego al pasar el cursor',
    gameDetailsOnHoverInfo: 'Permite configurar la información del juego que se mostrará al pasar el cursor.',
    bannerSet: 'Conjunto de banners',
    storySet: 'Conjunto de historias',
    depositButtonOnGames: 'Botón de depósito en juegos',
    depositButtonOnGamesHint: 'Cuando está activado, en la vista móvil los juegos mostrarán un botón de depósito. Si el juego tiene versión demo, el botón demo estará oculto por defecto.',
    mobileOrder: 'Orden móvil',
    desktopOrder: 'Orden escritorio',
    countdownWidget: 'Widget de cuenta regresiva',
    gameWidgetGameCountInfo: 'Solo los primeros {{count}} juegos activos se incluirán en el widget',
    gameGroupSegmentGamesInfo: 'Los cambios en el segmento del juego no afectarán a la entidad ya creada',
    gameGroupGameCountInfo: 'Solo los primeros {{count}} juegos activos se incluirán en el grupo',
    demoButtonOnGames: 'Botón Demo en los juegos',
    demoButtonOnGamesInfo: 'El botón Demo aparece solo si tanto la opción de Lanzamiento demo como la de Botón Demo están habilitadas para el dispositivo',
    groupList: 'Lista de grupos',
    groupListNote: 'En caso de que la configuración esté activa, el grupo será visible en el sitio web',
    zingBrainInfo: 'Proporciona juegos recomendados por ZingBrain',
    recommendationType: 'Tipo de recomendación',
    dynamicOrder: 'Orden dinámico',
  },
  tr: {
    cashier: 'Kasiyer',
    paymentLogo: 'Ödeme Logosu',
    methodName: 'Yöntem Adı',
    pgState: 'PG Durumu',
    platformState: 'Platform Durumu',
    allowedActivities: 'İzin Verilen Faaliyetler',
    supportedCountries: 'Desteklenen Ülkeler',
    depositSupportedCurrencies: 'Para Yatırmak için Desteklenen Para Birimleri',
    withdrawalSupportedCurrencies: 'Para Çekme için Desteklenen Para Birimleri',
    showForTags: 'Etiketler için Göster',
    hideForTags: 'Etiketler için Gizle',
    depositProcessingPeriod: 'Para Yatırma İşlem Süresi',
    withdrawalProcessingPeriod: 'Para Çekme İşlem Süresi',
    processingPeriod: 'İşlem Süresi',
    info: 'Bilgi',
    showInfoForDeposit: 'Para Yatırma Bilgilerini Göster',
    showInfoForWithdrawal: 'Para Çekme Bilgilerini Göster',
    processingRange: 'İşlem Aralığı',
    categoryName: 'Kategori Adı',
    lCategory: 'kategori',
    translationKeyInfo: 'Web sitesinde dile özgü adların görüntülenmesini sağlayan anahtar için çeviriler eklediğinizden emin olun.',
    deleteCategoryInfo: 'Kategorinin tüm ödeme yöntemleri Diğer sistem kategorisine taşınacaktır.',
    cashierDeposit: 'Para Yatırma Kasası',
    cashierWithdrawal: 'Para Çekme Kasası',
    depositState: 'Para Yatırma Durumu',
    withdrawalState: 'Para Çekme Durumu',
    generalComponentsInfo: 'Genel Bileşenler ile işaretlenmiştir',
    lSymbol: 'sembol',
    resetTranslationsInfo: 'Sıfırlama, mevcut bölümdeki tüm özel çevirileri kaldırır.',
    exportTranslationInfo: 'Çeviri anahtarları dahil edilecek',
    defaultTranslation: 'Varsayılan Çeviri',
    defaultTranslationInfo: 'Özel çeviri kaldırıldığında bu sütundaki çeviriler uygulanacaktır',
    addHintLanguage: 'İpucu Dili Ekle',
    selectHintsLanguage: 'İpuçları Dilini Seçin',
    deleteHintLanguage: 'İpucu Dilini Sil',
    section: 'Bölüm',
    chooseLanguage: 'Dil seçin',
    availableTranslationsBySections: 'Bölümlere Göre Mevcut Çeviriler',
    key: 'Anahtar',
    availableTranslations: 'Mevcut Çeviriler',
    createFolder: 'Klasör Oluştur',
    moveTo: 'Taşı',
    makeSureFileIsNotUsedInfo: 'Bu dosyanın hiçbir yerde kullanılmadığından emin olun.',
    makeSureFilesAreNotUsedInfo: 'Bu dosyaların hiçbir yerde kullanılmadığından emin olun.',
    folderName: 'Klasör Adı',
    filesUrlsChangedInfo: "Dosya URL'leri değişecek.",
    searchFolder: 'Arama Klasörü',
    move: 'Taşı',
    folders: 'Klasörler',
    rename: 'Yeniden isimlendir',
    folderFilesDeletedInfo: 'Klasördeki dosyalar da silinecektir.',
    totalSize: 'Toplam Boyut',
    contains: 'İçeren',
    file: 'Dosya',
    lFile: 'dosya',
    lFiles: 'Dosyalar',
    theFile: 'Dosya',
    files: 'Dosyalar',
    lFolder: 'klasör',
    folder: 'Klasör',
    lFolders: 'klasörler',
    fileName: 'Dosya Adı',
    dropHereOrUseUploadButton: '‎<0>Dosyaları buraya bırakın</0><1>veya Yükle butonunu kullanın.</1>',
    copyUrl: "Url'yi kopyala",
    extension: 'Uzantı',
    size: 'Boyut',
    dimensions: 'Boyutlar',
    url: 'URL',
    droppedFileInfo: 'Bırakılan dosyalar hemen bu klasöre yüklenecek',
    theTranslation: 'Çeviri',
    lSection: 'bölüm',
    thePaymentMethod: 'Ödeme yöntemi',
    theCategory: 'Kategori',
    cashierSettings: 'Kasa ayarları',
    fileOrFiles: 'Dosya(lar)',
    showingUpdates: 'Web sitesinde güncellemelerin gösterilmesi 30 saniye kadar sürebilir.',
    inputLanguageKeyHere: '‎{{languageName}}: Buraya girin',
    subCategory: 'Alt - Kategori',
    themes: 'Temalar',
    systemState: 'Sistem Durumu',
    maintenanceState: 'Bakım Durumu',
    maintenanceDates: 'Bakım Tarihleri',
    newTill: 'Yeni:',
    fixedTill: 'Sabit:',
    promoTill: 'Promosyon:',
    dateTill: 'Tarih:',
    newGame: 'Yeni oyun',
    fixedGame: 'Sabit Oyun',
    promoGame: 'Promosyon Oyunu',
    minLimit: 'Minimum Limit',
    maxLimit: 'Maksimum Limit',
    isCustom: 'Özel',
    standard: 'Standart',
    vertical: 'Dikey',
    horizontal: 'Yatay',
    background: 'Arka Plan',
    maintenanceDate: 'Bakım Tarihi',
    lGame: 'oyun',
    infinity: 'Sonsuzluk',
    new: 'Yeni',
    isNew: 'Yeni',
    fixed: 'Sabit',
    isFixed: 'Sabit',
    promo: 'Promosyon',
    isPromo: 'Promosyon',
    gameSettings: 'Oyun ayarları',
    maintenance: 'Bakım',
    gameGroup: 'Oyun Grubu',
    orderBy: 'Sıraya Göre',
    createGroup: 'Grup Oluşturma',
    lGroup: 'grup',
    set: 'Ayarla',
    groupType: 'Grup Türü',
    uploadListInfo: "Listeleri oyun ID'leri ile yükleyebilirsiniz. Sadece CSV formatı kabul edilir",
    thePaymentMethods: 'Ödeme yöntemleri',
    gridType: 'Grid Türü',
    providersPositioning: 'Sağlayıcıların Konumlandırılması',
    groups: 'Gruplar',
    gameDetailsPreviewInfo: 'Oyun detayları web sitesinde ön izleme ile gösterilir',
    gameDetailsCardInfo: 'Oyun detayları web sitesinde Kart Altbilgisi ile gösterilir',
    providerGamesCount: 'Sağlayıcı Oyun Sayısı',
    secondaryOrdering: 'İkincil Sıralama',
    advancedView: 'Gelişmiş Görünüm',
    lobbyProviders: 'Lobi Sağlayıcılar',
    providerOrder: 'Sağlayıcı Sıralama',
    gameOrder: 'Oyun Sıralaması',
    secondaryOrderingNote: 'İkincil Oyun Sıralaması, yapılandırma etkin olduğunda ve yalnızca bir sağlayıcı seçildiğinde çalışır, diğer tüm durumlarda gruba özel sıralama uygulanır.',
    providerOrderingNote: 'Varsayılan olarak veya işaretlenmediğinde, sağlayıcının alfabetik sıralaması uygulanır. İşaretlendiğinde, özel ayar sıralaması uygulanır',
    searchId: 'ID Arama',
    uploadGames: 'Oyun Yükle ',
    providerOrdering: 'Sağlayıcı Sıralaması',
    pageCap: 'Sayfa Başlığı',
    playerSpecificGamesAllowed: 'Oyuncuya Özel Oyunlara İzin Verildi',
    loggedInOnly: 'Yalnızca Oturum Açılan',
    visibleInMyCasino: 'Casinomda Görünür',
    visibleOnGameView: 'Oyun Görünümünde Görünür',
    visibleOnTheLeftBarMenu: 'Sol Çubuk Menüsünde Görünür',
    visibleOnMultiGameMenu: 'Çoklu Oyun Menüsünde Görünür',
    visibleOnNavigation: 'Navigasyonda Görünür',
    myCasino: "Casino'm",
    gameView: 'Oyun Görünümü',
    leftBarMenu: 'Sol Çubuk Menüsü',
    multiGameMenu: 'Çoklu Oyun Menüsü',
    navigation: 'Navigasyon',
    lobbies: 'Lobiler',
    visibleOn: 'Görünür',
    optional: 'Opsiyonel',
    lobbyWidgetsJackpotInfo: 'Lütfen unutmayın, sadece EGT jackpot feed için kullanılabilir',
    gameStatus: 'Oyun Durumu',
    gamesInfoNote: 'Oyun Bilgi Notu',
    gamesInfoNoteHint: 'Oyun bilgi notu butonu web sitesinde kullanılabilir ',
    providerId: 'Sağlayıcı ID',
    gameBackground: 'Oyun Arka Planı',
    gameBackgroundHint: 'Etkinleştirilirse, oyunların arka plan görüntüleri lobilerden başlatıldığında web sitesinde görünür ',
    myCasinoHint: 'Etkinleştirilirse, "Casino\'m" alt bölümü web sitesinin mobil görünümünde mevcut olur',
    media: 'Medya',
    mobilePageCap: 'Mobil Uygulamalar için Sayfa Başlığı',
    lGames: 'oyunlar',
    lGameType: 'oyun türü',
    typeName: 'Adını yazın',
    gameVerticalType: 'Oyun Dikey Türü',
    haveAssignedType: 'Atanan tür',
    createGameType: 'Oyun Türü Oluştur',
    jackpotAmountOnHoverInfo: 'Kullanıcı lobide bir oyun küçük resminin üzerine geldiğinde jackpot tutarı görüntülenir.',
    jackpotAmountOnThumbnailInfo: 'Jackpot tutarı oyun küçük resim çerçevesinin içinde görüntülenir',
    visibleInGamesSeoPage: 'Oyunların SEO sayfasında görüntülenir',
    providerViewingType: 'Sağlayıcı Görüntüleme Türü',
    providerLogo: 'Sağlayıcı Logosu',
    widgetIcon: 'Widget Simgesi',
    widgetContentType: 'İçerik Türü',
    desktopBackground: 'Masaüstü Arka Planı',
    mobileBackground: 'Mobil Arka Planı',
    gameMainSettings: 'Oyun Ana Ayarları',
    imageGridType: 'Resim Düzeni Tipi',
    small: 'Küçük',
    row: 'Satır',
    gameCap: 'Oyun Capı',
    gameSelection: 'Oyun Seçimi',
    lobbyHome: 'Lobi Ana Sayfa',
    lobbyHomeHint: 'Lobi için statik Widget-Base “Lobi Ana Sayfası”nın kullanılabilirliğini belirtir.',
    navigationBar: 'Gezinti Çubuğu',
    navigationBarHint: 'Ana Lobi ve “Lobi Ana Sayfası” sayfalarında Navigasyon Çubuğunun kullanılabilirliğini belirtir.',
    isSmallImageSizeInfo: 'Küçük seçildiğinde,  görüntü boyutları web sitesinde daha küçük boyutlara değiştirilir.',
    widgetVisibilityInfo: 'El widget será visible solo para jugadores con sesión iniciada.',
    wins: 'Kazançlar',
    winType: 'Kazanç Türü',
    groupSelection: 'Grup Seçimi',
    viewingType: 'Görüntüleme Türü',
    group: 'Grup',
    items: 'Öğeler',
    groupViewingType: 'Grup Görüntüleme Türü',
    uploadProviderInfo: 'Sağlayıcı listesini yükleyebilirsiniz. Yalnızca CSV formatı kabul edilir.',
    randomGamesWidgetInfo: 'Seçilen oyunlar kaydedilecek ve widget için rastgele sıralanacaktır.',
    widgetImage: 'Widget Resmi',
    widgetBackground: 'Widget Arka Planı',
    desktopImage: 'Masaüstü Görüntüsü',
    mobileImage: 'Mobil Görüntüsü',
    providerAndGamesSelection: 'Sağlayıcı ve Oyun Seçimi',
    searchPopup: 'Arama Pop-up',
    visibleInSearchPopUp: "Arama Pop-up'ında Görüntülenir",
    jackpotSet: 'Jackpot Seti',
    gameUpload: 'Oyun Yükleme',
    parallaxInfo: 'Paralaks çözümü etkinleştirilirse, dört medya da etkinleştirilmelidir.',
    parallax: 'Parallax',
    manageCollection: 'Koleksiyonu Yönet',
    cap: 'Cap',
    uploadImage: 'Resim yükle',
    viewImage: 'Resmi Görüntüle',
    image: 'Resim',
    gameDetailsOnHover: 'Fareyi üzerine getirdiğinizde oyun detayları',
    gameDetailsOnHoverInfo: 'Fareyi üzerine getirdiğinizde gösterilecek oyun bilgilerini yapılandırmanıza olanak tanır.',
    bannerSet: 'Afiş Seti',
    storySet: 'Hikaye Seti',
    depositButtonOnGames: 'Oyunlarda Para Yatırma Düğmesi',
    depositButtonOnGamesHint: 'Etkinleştirildiğinde, Mobil görünümdeki oyunlarda Para Yatırma Düğmesi olacaktır. Oyunların Demo sürümü varsa, Demo Düğmesi varsayılan olarak gizlenecektir.',
    mobileOrder: 'Mobil Sıralama',
    desktopOrder: 'Masaüstü Sıralama',
  },
  ru: {
    cashier: 'Касса',
    paymentLogo: 'Логотип платежной системы',
    methodName: 'Название метода',
    pgState: 'Состояние PG',
    platformState: 'Состояние платформы',
    allowedActivities: 'Разрешенные действий',
    supportedCountries: 'Поддерживаемые страны',
    depositSupportedCurrencies: 'Поддерживаемые валюты для внесений средств',
    withdrawalSupportedCurrencies: 'Поддерживаемые валюты длѝ вывода ѝредѝтв',
    showForTags: 'Показать теги',
    hideForTags: 'Скрыть теги',
    depositProcessingPeriod: 'Период обработки депозитов',
    withdrawalProcessingPeriod: 'Вид обработки вывода средств',
    processingPeriod: 'Период обработки',
    info: 'Информаций',
    showInfoForDeposit: 'Показать информацию по депозитам',
    showInfoForWithdrawal: 'Показать информацию по выводу ѝредѝтв',
    processingRange: 'Диапазон обработки',
    categoryName: 'Название категории',
    lCategory: 'категория',
    translationKeyInfo: 'Обязательно добавьте переводы для ключа, чтобы на сайте отображались названия для конкретных языков.',
    deleteCategoryInfo: 'Все методы оплаты этой категории будут перемещены в системную категорию «Другие»',
    cashierDeposit: 'Внесение средств через кассу',
    cashierWithdrawal: 'Вывод средств через кассу',
    depositState: 'Состояние депозитов',
    withdrawalState: 'Состояние вывода средств',
    generalComponentsInfo: 'Общие компоненты отмечены',
    lSymbol: 'символ',
    resetTranslationsInfo: 'Сброс удалит все пользовательские переводы в выбранном разделе.',
    exportTranslationInfo: 'Ключи перевода будут включены',
    defaultTranslation: 'Стандартный перевод',
    defaultTranslationInfo: 'После удалениѝ пользовательского перевода будет использоваться перевод из этой колонки',
    addHintLanguage: 'Добавить язык подсказок',
    selectHintsLanguage: 'Выбрать язык подсказок',
    deleteHintLanguage: 'Удалить язык подсказок',
    section: 'Раздел',
    chooseLanguage: 'Выбрать язык',
    availableTranslationsBySections: 'Доступный перевод по разделам',
    key: 'Ключ',
    availableTranslations: 'Доступные переводы',
    createFolder: 'Создать папку',
    moveTo: 'Переместить в',
    makeSureFileIsNotUsedInfo: 'Убедитесь, что этот файл нигде не используется.',
    makeSureFilesAreNotUsedInfo: 'Убедитеѝь, что ѝти файлы нигде не иѝпользуютѝѝ.',
    folderName: 'Название папки',
    filesUrlsChangedInfo: 'URL файлов будут изменены.',
    searchFolder: 'Найти папку',
    move: 'Переместить',
    folders: 'Папки',
    rename: 'Переименовать',
    folderFilesDeletedInfo: 'Файлы в папке также будут удалены.',
    totalSize: 'Общий размер',
    contains: 'Содержит',
    file: 'Файл',
    lFile: 'файл',
    lFiles: 'файлы',
    theFile: 'Файл',
    files: 'Файлы',
    lFolder: 'папка',
    folder: 'Папка',
    lFolders: 'папки',
    fileName: 'Название файла',
    dropHereOrUseUploadButton: '<0>Перетащите файлы ѝюда</0><1>или иѝпользуйте кнопку «Загрузить».</1>',
    copyUrl: 'Копировать URL',
    extension: 'Расширение',
    size: 'Размер',
    dimensions: 'Параметры',
    url: 'URL',
    droppedFileInfo: 'Перетянутые файлы будут сразу же загружены в эту папку',
    theTranslation: 'Перевод',
    lSection: 'раздел',
    thePaymentMethod: 'Способ оплаты',
    theCategory: 'Категория',
    cashierSettings: 'Настройки кассы',
    fileOrFiles: 'Файл(ы)',
    showingUpdates: 'Отображение обновлений на сайте может занять до 30 секунд.',
    inputLanguageKeyHere: '{{languageName}}: Введите здесь',
    subCategory: 'Подкатегориѝ',
    themes: 'Темы',
    systemState: 'Состояние системы',
    maintenanceState: 'Состояние обслуживания',
    maintenanceDates: 'Даты обѝлуживаниѝ',
    newTill: 'Новаѝ каѝѝа',
    fixedTill: 'Фиксированная касса',
    promoTill: 'Промокасса',
    dateTill: 'Дата кассы',
    newGame: 'Новая игра',
    fixedGame: 'Фиксированная игра',
    promoGame: 'Промо-игра',
    minLimit: 'Мин. лимит',
    maxLimit: 'Макс. лимит',
    isCustom: 'Пользовательские настройки',
    standard: 'Стандартные',
    vertical: 'Вертикальные',
    horizontal: 'Горизонтальные',
    background: 'Фон',
    maintenanceDate: 'Дата обслуживания',
    lGame: 'игра',
    infinity: 'Бесконечность',
    new: 'Новые',
    isNew: 'Новый(-ая)',
    fixed: 'Фиксированные',
    isFixed: 'Фиксированный(-ая)',
    promo: 'Промо',
    isPromo: 'Промо',
    gameSettings: 'Настройки игры',
    maintenance: 'Обслуживание',
    gameGroup: 'Группа игр',
    orderBy: 'Упорядочить по',
    createGroup: 'Создать группу',
    lGroup: 'группа',
    set: 'Установить',
    groupType: 'Тип группы',
    uploadListInfo: 'Вы можете загружать списки с игровыми ID. Принимается только формат CSV',
    thePaymentMethods: 'Способы оплаты',
    gridType: 'Тип сетки',
    providersPositioning: 'Порядок размещениѝ провайдеров',
    groups: 'Группы',
    gameDetailsPreviewInfo: 'Детали игры отображаются на сайте с возможностью предварительного просмотра',
    gameDetailsCardInfo: 'Детали игры показаны на веб-сайте с помощью Card Footer.',
    providerGamesCount: 'Количество игр провайдера',
    secondaryOrdering: 'Вторичное упорядочение',
    advancedView: 'Расширенный вид',
    lobbyProviders: 'Провайдеры лобби',
    providerOrder: 'Порядок провайдера',
    gameOrder: 'Порядок игры',
    secondaryOrderingNote: 'Вторичное упорядочивание игр работает, когда конфигурациѝ активна и выбран только один провайдер, в любом другом случае применяется групповое упорядочивание.',
    providerOrderingNote: 'По умолчанию или если флажок снят, устанавливается алфавитный порядок провайдера. Если флажок установлен, применяется пользовательский порядок',
    searchId: 'ID поиска',
    uploadGames: 'Загрузить игры',
    providerOrdering: 'Упорядочивание провайдеров',
    pageCap: 'Шапка страницы',
    playerSpecificGamesAllowed: 'Разрешенные игры для конкретного игрока',
    loggedInOnly: 'Только для входа в систему',
    visibleInMyCasino: 'Видно в Моем казино',
    visibleOnGameView: 'Видно в режиме просмотра игры',
    visibleOnTheLeftBarMenu: 'Видно в меню левой панели',
    visibleOnMultiGameMenu: 'Видно в меню нескольких игр',
    visibleOnNavigation: 'Видно в навигации',
    myCasino: 'Мое казино',
    gameView: 'Вид игры',
    leftBarMenu: 'Меню левой панели',
    multiGameMenu: 'Меню нескольких игр',
    navigation: 'Навигация',
    lobbies: 'Лобби',
    visibleOn: 'Видно на',
    optional: 'Дополнительно',
    lobbyWidgetsJackpotInfo: 'Обратите внимание, доступно только для подачи джекпота EGT',
    gameStatus: 'Статус игры',
    gamesInfoNote: 'Информационная заметка об играх',
    gamesInfoNoteHint: 'Кнопка информационной заметки об играх становится доступной на сайте',
    providerId: 'ID провайдера',
    gameBackground: 'Фон игры',
    gameBackgroundHint: 'Если эта функция включена, фоновые изображениѝ игр будут доступны на сайте при запуске из лобби',
    myCasinoHint: 'Еѝли ѝта функциѝ включена, то подраздел «Мое казино» ѝтановитѝѝ доѝтупным при проѝмотре мобильной верѝии ѝайта',
    media: 'Медиа',
    mobilePageCap: 'Шапка страницы для мобильных приложений',
    lGames: 'игры',
    lGameType: 'тип игры',
    typeName: 'Название типа',
    gameVerticalType: 'Вертикальный тип игры',
    haveAssignedType: 'Назначенный тип',
    createGameType: 'Создать тип игры',
    jackpotAmountOnHoverInfo: 'Сумма джекпота отображается, когда пользователь наводит курсор на иконку игры в лобби',
    jackpotAmountOnThumbnailInfo: 'Сумма джекпота отображается в иконке игры',
    visibleInGamesSeoPage: 'Видимые на SEO-странице игр',
    providerViewingType: 'Тип просмотра провайдера',
    providerLogo: 'Логотип провайдера',
    widgetIcon: 'Иконка виджета',
    widgetContentType: 'Тип контента',
    desktopBackground: 'Фон рабочего стола',
    mobileBackground: 'Мобильный фон',
    gameMainSettings: 'Основные настройки игры',
    imageGridType: 'Тип сетки изображений',
    small: 'Маленький',
    row: 'Ряд',
    gameCap: 'Игровой колпачок',
    gameSelection: 'Выбор игры',
    lobbyHome: 'Домашняя страница лобби',
    lobbyHomeHint: 'Определяет наличие статической страницы «Домашняя страница лобби» на основе виджетов для лобби.',
    navigationBar: 'Навигационная панель',
    navigationBarHint: 'Указывает наличие навигационной панели для страниц «Основное лобби» и «Домашняя страница лобби».',
    isSmallImageSizeInfo: 'Если выбрано значение «Маленький», размеры изображений на веб-сайте изменяются на меньшие.',
    widgetVisibilityInfo: 'Виджет будет виден только вошедшим в систему игрокам',
    wins: 'Выигрыш',
    winType: 'Тип выигрыша',
    groupSelection: 'Выбор группы',
    viewingType: 'Тип просмотра',
    group: 'Группа',
    items: 'Элементы',
    groupViewingType: 'Тип просмотра группы',
    uploadProviderInfo: 'Вы можете загрузить список провайдеров. Допускается только формат CSV',
    randomGamesWidgetInfo: 'Выбранные игры будут сохранены и рандомизированы для виджета.',
    widgetImage: 'Изображение виджета',
    widgetBackground: 'Фон виджета',
    desktopImage: 'Изображение рабочего стола',
    mobileImage: 'Мобильное изображение',
    providerAndGamesSelection: 'Выбор провайдера и игр',
    searchPopup: 'Всплывающее окно поиска',
    visibleInSearchPopUp: 'Видно во всплывающем окне поиска',
    jackpotSet: 'Комплект джекпотов',
    gameUpload: 'Загрузка игры',
    parallaxInfo: 'В случае активации решения параллакса должны быть задействованы четыре носителя информации',
    parallax: 'Параллакс',
    manageCollection: 'Управление коллекцией',
    cap: 'Колпачок',
    uploadImage: 'Загрузить изображение',
    viewImage: 'Просмотр изображения',
    image: 'Изображение',
    gameDetailsOnHover: 'Подробности игры в Hover',
    gameDetailsOnHoverInfo: 'Позволяет настроить отображение информации об игре при наведении курсора',
    bannerSet: 'Комплект баннеров',
    storySet: 'Комплект историй',
    depositButtonOnGames: 'Кнопка депозита в играх',
    depositButtonOnGamesHint: 'После активации игры на мобильном экране появится кнопка депозита. Если игры имеют демо-версию, кнопка демо будет скрыта по умолчанию',
    mobileOrder: 'Мобильный заказ',
    desktopOrder: 'Заказ для рабочего стола',
    countdownWidget: 'Виджет обратного отсчёта',
    gameWidgetGameCountInfo: 'В виджет будут включены только первые {{count}} активных игр',
    gameGroupSegmentGamesInfo: 'Изменения в сегменте игр не повлияют на уже созданный объект',
    gameGroupGameCountInfo: 'В группу будут включены только первые {{count}} активных игр',
    demoButtonOnGames: 'Кнопка демоверсии для игр',
    demoButtonOnGamesInfo: 'Кнопка демоверсии отображается только в том случае, если для устройства включены настройки запуска демоверсии и кнопки демоверсии',
    groupList: 'Список групп',
    groupListNote: 'Если настройка активна, группа будет видна на веб-сайте',
    zingBrainInfo: 'Предоставляет игры, рекомендованные ZingBrain',
    recommendationType: 'Тип рекомендации',
    dynamicOrder: 'Динамический порядок',
  },
  pt: {
    cashier: 'Caixa',
    paymentLogo: 'Logotipo de Pagamento',
    methodName: 'Nome do Método',
    pgState: 'Estado PG',
    platformState: 'Estado da Plataforma',
    allowedActivities: 'Atividades Permitidas',
    supportedCountries: 'Países Compatíveis',
    depositSupportedCurrencies: 'Moedas Compatíveis para Depósito',
    withdrawalSupportedCurrencies: 'Moedas Compatíveis para Retirada',
    showForTags: 'Mostrar para Tags',
    hideForTags: 'Ocultar para Tags',
    depositProcessingPeriod: 'Período de Processamento de Depósito',
    withdrawalProcessingPeriod: 'Período de Processamento de Retirada',
    processingPeriod: 'Período de Processamento',
    info: 'Informação',
    showInfoForDeposit: 'Mostrar Informação para Depósito',
    showInfoForWithdrawal: 'Mostrar Informação para Retirada',
    processingRange: 'Intervalo de Processamento',
    categoryName: 'Nome da Categoria',
    lCategory: 'categoria',
    translationKeyInfo: 'Certifique-se de que adiciona traduções para a chave, por forma a que os nomes específicos dos idiomas sejam exibidos no site',
    deleteCategoryInfo: 'Todos os métodos de pagamento da categoria serão movidos para a categoria de sistema Outros',
    cashierDeposit: 'Depósito em Caixa',
    cashierWithdrawal: 'Retirada em Caixa',
    depositState: 'Estado do Depósito',
    withdrawalState: 'Estado da Retirada',
    generalComponentsInfo: 'Os Componentes Gerais são marcados com',
    lSymbol: 'símbolo',
    resetTranslationsInfo: 'Ao reiniciar, removerá todas as traduções personalizadas na seção atual.',
    exportTranslationInfo: 'As chaves de tradução serão incluídas',
    defaultTranslation: 'Tradução Padrão',
    defaultTranslationInfo: 'As traduções nesta coluna serão aplicadas quando a tradução personalizada for removida.',
    addHintLanguage: 'Acrescentar Idioma de Dicas',
    selectHintsLanguage: 'Selecionar Idioma de Dicas',
    deleteHintLanguage: 'Excluir Idimoma de Dicas',
    section: 'Seção',
    chooseLanguage: 'Escolha o Idioma',
    availableTranslationsBySections: 'Traduções Disponíveis por Seções',
    key: 'Chave',
    availableTranslations: 'Traduções Disponíveis',
    createFolder: 'Criar Pasta',
    moveTo: 'Mover para',
    makeSureFileIsNotUsedInfo: 'Certifique-se de que este arquivo não é utilizado em qualquer lugar.',
    makeSureFilesAreNotUsedInfo: 'Certifique-se de que estes arquivos não sejam utilizados em qualquer lugar.',
    folderName: 'Nome da Pasta',
    filesUrlsChangedInfo: 'As URLs dos arquivos serão alteradas.',
    searchFolder: 'Procurar Pasta',
    move: 'Mover',
    folders: 'Pastas',
    rename: 'Renomear',
    folderFilesDeletedInfo: 'Os arquivos na pasta também serão excluídos.',
    totalSize: 'Tamanho Total',
    contains: 'Contém',
    file: 'Arquivo',
    lFile: 'arquivo',
    lFiles: 'arquivos',
    theFile: 'O arquivo',
    files: 'Arquivos',
    lFolder: 'pasta',
    folder: 'Pasta',
    lFolders: 'pastas',
    fileName: 'Nome do Arquivo',
    dropHereOrUseUploadButton: '<0>Solte os arquivos aqui</0><1> ou use o botão Upload.</1>',
    copyUrl: 'Copiar URL',
    extension: 'Extensão',
    size: 'Tamanho',
    dimensions: 'Dimensões',
    url: 'URL',
    droppedFileInfo: 'Os arquivos soltos aqui serão imediatamente carregados para esta pasta',
    theTranslation: 'A tradução',
    lSection: 'seção',
    thePaymentMethod: 'O método de pagamento',
    theCategory: 'A categoria',
    cashierSettings: 'Configurações do caixa',
    fileOrFiles: 'Arquivo(s)',
    showingUpdates: 'Pode levar até 30 segundos para as atualizações serem exibidas no site.',
    inputLanguageKeyHere: '{{languageName}}: Informações aqui',
    subCategory: 'Sub - Categoria',
    themes: 'Temas',
    systemState: 'Estado do Sistema',
    maintenanceState: 'Estado de Manutenção',
    maintenanceDates: 'Datas de Manutenção',
    newTill: 'Nova Caixa',
    fixedTill: 'Caixa Fixa',
    promoTill: 'Caixa Promocional',
    dateTill: 'Datar a Caixa',
    newGame: 'Novo Jogo',
    fixedGame: 'Jogo Fixo',
    promoGame: 'Jogo Promocional',
    minLimit: 'Limite Mín.',
    maxLimit: 'Limite Máx.',
    isCustom: 'É Personalizado',
    standard: 'Padrão',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    background: 'Fundo',
    maintenanceDate: 'Data de Manutenção',
    lGame: 'jogo',
    infinity: 'Infinito',
    new: 'Novo',
    isNew: 'É Novo',
    fixed: 'Fixo',
    isFixed: 'Está Fixo',
    promo: 'Promoção',
    isPromo: 'É Promoção',
    gameSettings: 'Configurações do jogo',
    maintenance: 'Manutenção',
    gameGroup: 'Grupo do Jogo',
    orderBy: 'Ordenar por',
    createGroup: 'Criar um Grupo',
    lGroup: 'grupo',
    set: 'Conjunto',
    groupType: 'Tipo de Grupo',
    uploadListInfo: 'Pode carregar listas com as ID dos jogos. É aceite apenas o formato CSV',
    thePaymentMethods: 'As formas de pagamento',
    gridType: 'Tipo de grade',
    providersPositioning: 'Posicionamento do Provedor',
    groups: 'Grupos',
    gameDetailsPreviewInfo: 'Os detalhes do jogo são mostrados no site com visualização prévia',
    gameDetailsCardInfo: 'Os detalhes do jogo são mostrados no site com Card Footer',
    providerGamesCount: 'Contagem de jogos do provedor',
    secondaryOrdering: 'Pedidos Secundários',
    advancedView: 'Visualização avançada',
    lobbyProviders: 'Fornecedores do Lobby',
    providerOrder: 'Ordem do prestador',
    gameOrder: 'Ordem de jogo',
    secondaryOrderingNote:
      'A ordenação secundária do jogo funciona quando a configuração está ativa e apenas um fornecedor está selecionado, em qualquer outro caso é aplicada uma ordenação específica do grupo.',
    providerOrderingNote: 'Por predefinição ou quando não está selecionada, é definida a ordem alfabética do fornecedor. Quando selecionada, é aplicada a ordem personalizada definida',
    searchId: 'Procurar ID',
    uploadGames: 'Transferir jogos',
    providerOrdering: 'Encomenda de fornecedores',
    pageCap: 'Limite da página',
    playerSpecificGamesAllowed: 'Jogos específicos do jogador permitidos',
    loggedInOnly: 'Apenas com registo',
    visibleInMyCasino: 'Visível em Meu Casino',
    visibleOnGameView: 'Visível na Vista do Jogo',
    visibleOnTheLeftBarMenu: 'Visível na barra do menu esquerda',
    visibleOnMultiGameMenu: 'Visível no menu multi-jogo',
    visibleOnNavigation: 'Visível na Navegação',
    myCasino: 'Meu Casino',
    gameView: 'Visualização do jogo',
    leftBarMenu: 'Barra de Menu Esquerda',
    multiGameMenu: 'Menu Multijogo',
    navigation: 'Navegação',
    lobbies: 'Lobbies',
    visibleOn: 'Visível em',
    optional: 'Opcional',
    lobbyWidgetsJackpotInfo: 'Nota: apenas disponível para a alimentação do jackpot EGT',
    gameStatus: 'Estado do Jogo',
    gamesInfoNote: 'Nota informativa sobre os jogos',
    gamesInfoNoteHint: 'O botão da nota informativa dos jogos fica disponível no sítio Web',
    providerId: 'ID do fornecedor',
    gameBackground: 'Fundo do jogo',
    gameBackgroundHint: 'Se ativado, as imagens de fundo dos jogos ficam disponíveis no sítio Web, ao iniciar a partir dos lobbies',
    myCasinoHint: 'Se ativado, a subsecção "O meu Casino" fica disponível na vista móvel do sítio Web',
    media: 'Média',
    mobilePageCap: 'Limite de páginas para aplicações móveis',
    lGames: 'jogos',
    lGameType: 'tipo do jogo',
    typeName: 'Nome do tipo',
    gameVerticalType: 'Tipo de jogo vertical',
    haveAssignedType: 'Tem tipo atribuído',
    createGameType: 'Criar tipo de jogo',
    jackpotAmountOnHoverInfo: 'O valor do jackpot é exibido quando o usuário passa o mouse sobre a miniatura do jogo no lobby',
    jackpotAmountOnThumbnailInfo: 'O valor do jackpot é exibido dentro da moldura da miniatura do jogo.',
    visibleInGamesSeoPage: 'Visível na página de SEO de jogos',
    providerViewingType: 'Tipo de visualização do provedor',
    providerLogo: 'Logotipo do provedor',
    widgetIcon: 'Ícone do widget',
    widgetContentType: 'Tipo de conteúdo',
    desktopBackground: 'Plano de fundo da área de trabalho',
    mobileBackground: 'Plano de fundo do celular',
    gameMainSettings: 'Configurações principais do jogo',
    imageGridType: 'Tipo de grade de imagem',
    small: 'Pequeno',
    row: 'Linha',
    gameCap: 'Limite de jogos',
    gameSelection: 'Seleção de jogos',
    lobbyHome: 'Página inicial do lobby',
    lobbyHomeHint: 'Especifica a disponibilidade de uma página inicial do lobby baseada em widget estático para o lobby.',
    navigationBar: 'Barra de navegação',
    navigationBarHint: 'Especifica a disponibilidade de uma Barra de Navegação para as páginas do Lobby Principal e "Página Inicial do Lobby".',
    isSmallImageSizeInfo: 'Caso a opção Pequeno seja selecionada, os tamanhos das imagens serão alterados para tamanhos menores no Site.',
    widgetVisibilityInfo: 'O widget ficará visível apenas para jogadores logados',
    wins: 'Ganhos',
    winType: 'Tipo de ganho',
    groupSelection: 'Seleção de grupo',
    viewingType: 'Tipo de visualização',
    group: 'Grupo',
    items: 'Itens',
    groupViewingType: 'Tipo de visualização de grupo',
    uploadProviderInfo: 'Você pode enviar a lista de provedores. Somente o formato CSV é aceito.',
    randomGamesWidgetInfo: 'Os jogos selecionados serão salvos e randomizados para o widget.',
    widgetImage: 'Imagem do widget',
    widgetBackground: 'Fundo do widget',
    desktopImage: 'Imagem para Desktop',
    mobileImage: 'Imagem para celular',
    providerAndGamesSelection: 'Seleção de provedores e jogos',
    searchPopup: 'Pop-up de busca',
    visibleInSearchPopUp: 'Visível no pop-up de busca',
    jackpotSet: 'Conjunto de jackpot',
    gameUpload: 'Upload de jogos',
    parallaxInfo: 'Caso a solução de paralaxe seja ativada, os quatro meios devem ser ativados',
    parallax: 'Parallax',
    manageCollection: 'Gerenciar coleção',
    cap: 'Limite',
    uploadImage: 'Carregar imagem',
    viewImage: 'Ver imagem',
    image: 'Imagem',
    gameDetailsOnHover: 'Detalhes do jogo ao passar o mouse',
    gameDetailsOnHoverInfo: 'Permite configurar as informações do jogo a serem mostradas ao passar o mouse',
    bannerSet: 'Conjunto de banners',
    storySet: 'Conjunto de histórias',
    depositButtonOnGames: 'Botão de depósito em jogos',
    depositButtonOnGamesHint: 'Quando ativados, os jogos na versão Mobile terão um botão de depósito. Caso os jogos tenham a versão Demo, o botão Demo ficará oculto por padrão.',
    mobileOrder: 'Ordem para Dispositivos Móveis',
    desktopOrder: 'Ordem para Desktop',
    countdownWidget: 'Widget de contagem regressiva',
    gameWidgetGameCountInfo: 'Apenas os primeiros {{count}} jogos ativos serão incluídos no widget',
    gameGroupSegmentGamesInfo: 'Alterações no segmento de jogos não afetarão entidades já criadas',
    gameGroupGameCountInfo: 'Apenas os primeiros {{count}} jogos ativos serão incluídos no grupo',
    demoButtonOnGames: 'Botão Demo nos jogos',
    demoButtonOnGamesInfo: 'O botão Demo só aparece se as configurações "Iniciar Demo" e "Botão Demo" estiverem ativadas para o dispositivo.',
    groupList: 'Lista de grupos',
    groupListNote: 'Caso a configuração esteja ativa, o grupo ficará visível no site',
    zingBrainInfo: 'Fornece jogos recomendados pela ZingBrain',
    recommendationType: 'Tipo de recomendação',
    dynamicOrder: 'Ordem dinâmica',
  },
  zh: {
    cashier: '出纳员',
    paymentLogo: '付款徽标',
    methodName: '方弝坝称',
    pgState: '支付网关状思',
    platformState: '平坰状思',
    allowedActivities: '兝许的活动',
    supportedCountries: '支挝的国家',
    depositSupportedCurrencies: '存款支挝货帝',
    withdrawalSupportedCurrencies: '块支挝的坖款货帝',
    showForTags: '显示标记',
    hideForTags: '隝藝标记',
    depositProcessingPeriod: '存款处睆周期',
    withdrawalProcessingPeriod: '坖款处睆周期',
    processingPeriod: '处睆周期',
    info: '信杯',
    showInfoForDeposit: '显示存款信杯',
    showInfoForWithdrawal: '显示坖款信杯',
    processingRange: '处睆范围',
    categoryName: '类别坝称',
    lCategory: '类别',
    translationKeyInfo: '请确保为该密钥添加翻译，以便在网站上显示特定语言的坝称',
    deleteCategoryInfo: '该类别的所有付款方弝将移至其他系统类别',
    cashierDeposit: '出纳存款',
    cashierWithdrawal: '出纳坖款',
    depositState: '存款状思',
    withdrawalState: '坖款状思',
    generalComponentsInfo: '一般部件都标有',
    lSymbol: '标志',
    resetTranslationsInfo: '針置将删除当剝部分的所有自定义翻译。',
    exportTranslationInfo: '将包括翻译钥匙',
    defaultTranslation: '默认翻译',
    defaultTranslationInfo: '当自定义翻译被删除时，此列中的翻译将被应用。',
    addHintLanguage: '添加杝示语言',
    selectHintsLanguage: '选择杝示语言',
    deleteHintLanguage: '删除杝示语言',
    section: '部分',
    chooseLanguage: '选择语言',
    availableTranslationsBySections: '按版块划分的坯用翻译',
    key: '密钥',
    availableTranslations: '坯用翻译',
    createFolder: '创建文件夹',
    moveTo: '移至',
    makeSureFileIsNotUsedInfo: '确保此文件丝用于任何地方。',
    makeSureFilesAreNotUsedInfo: '确保这些文件丝用于任何地方。',
    folderName: '文件夹坝称',
    filesUrlsChangedInfo: '文件的URL将进行更改。',
    searchFolder: '杜索文件夹',
    move: '移动',
    folders: '文件夹',
    rename: '針命坝',
    folderFilesDeletedInfo: '文件夹中的文件也将一并删除。',
    totalSize: '总大尝',
    contains: '包坫',
    file: '文件',
    lFile: '文件',
    lFiles: '文件',
    theFile: '文件',
    files: '文件',
    lFolder: '文件夹',
    folder: '文件夹',
    lFolders: '文件夹',
    fileName: '文件坝',
    dropHereOrUseUploadButton: '<0>在这里投放文件</0><1>或使用上传按钮</1>。',
    copyUrl: '夝制URL',
    extension: '扩展',
    size: '大尝',
    dimensions: '尺寸',
    url: 'URL',
    droppedFileInfo: '掉蝽的文件将被立坳上传到这个文件夹。',
    theTranslation: '翻译',
    lSection: '部分',
    thePaymentMethod: '付款方弝',
    theCategory: '类别',
    cashierSettings: '出纳设置',
    fileOrFiles: '文件',
    showingUpdates: '在网站上显示更新最长坯能需覝30秒。',
    inputLanguageKeyHere: '{{languageName}}：请在此处输入',
    subCategory: '孝—类别',
    themes: '主题',
    systemState: '系统状思',
    maintenanceState: '维护状思',
    maintenanceDates: '维护日期',
    newTill: '新至',
    fixedTill: '固定至',
    promoTill: '促销至',
    dateTill: '日期至',
    newGame: '新游戝',
    fixedGame: '固定游戝',
    promoGame: '促销游戝',
    minLimit: '最尝陝制',
    maxLimit: '最大陝制',
    isCustom: '自定义的',
    standard: '标准',
    vertical: '垂直',
    horizontal: '水平',
    background: '背景',
    maintenanceDate: '维护日期',
    lGame: '游戝',
    infinity: '无陝',
    new: '新',
    isNew: '新',
    fixed: '固定',
    isFixed: '固定的',
    promo: '促销',
    isPromo: '促销',
    gameSettings: '游戝设置',
    maintenance: '维护',
    gameGroup: '游戝组',
    orderBy: '订购',
    createGroup: '创建组',
    lGroup: '组',
    set: '设置',
    groupType: '组类型',
    uploadListInfo: '您坯以上传带有比赛ID的列表。我们仅接块CSV格弝',
    thePaymentMethods: '付款方弝',
    gridType: '网格类型',
    providersPositioning: '杝供商定佝',
    groups: '尝组',
    gameDetailsPreviewInfo: '游戝细节显示在网站上，并附有预览',
    gameDetailsCardInfo: '游戝细节显示在网站的坡脚上',
    providerGamesCount: '杝供商游戝计数',
    secondaryOrdering: '二级订坕组织',
    advancedView: '高级视图',
    lobbyProviders: '大厅杝供商',
    providerOrder: '杝供商订坕',
    gameOrder: '游戝订坕',
    secondaryOrderingNote: '当酝置处于活跃状思且坪选择了一个杝供商时，二级游戝排庝扝会起作用，在任何其他情况下，都会应用特定组的排庝。',
    providerOrderingNote: '默认情况下或未选中时，将设置杝供商字毝顺庝。选中时，应用自定义设置的顺庝',
    searchId: '杜索ID',
    uploadGames: '上传游戝',
    providerOrdering: '杝供商订购',
    pageCap: '\n页首\n',
    playerSpecificGamesAllowed: '兝许的特定玩家游戝',
    loggedInOnly: '仅陝已登录',
    visibleInMyCasino: '在我的赌场坯觝',
    visibleOnGameView: '游戝视图中坯觝',
    visibleOnTheLeftBarMenu: '坯觝于左侧栝蝜坕',
    visibleOnMultiGameMenu: '多游戝蝜坕上坯觝',
    visibleOnNavigation: '导航中坯觝',
    myCasino: '我的赌场',
    gameView: '游戝视图',
    leftBarMenu: '左侧栝',
    multiGameMenu: '多游戝蝜坕',
    navigation: '导航',
    lobbies: '大厅',
    visibleOn: '坯觝于',
    optional: '坯选',
    lobbyWidgetsJackpotInfo: '请注愝，仅适用于EGT大奖功能',
    gameStatus: '游戝状思',
    gamesInfoNote: '游戝须知',
    gamesInfoNoteHint: '网站上有游戝须知按钮',
    providerId: '杝供商ID',
    gameBackground: '游戝背景',
    gameBackgroundHint: '如果坯用，从大厅坯动游戝时，网站上会显示游戝背景图片',
    myCasinoHint: '如果坯用，“我的赌场”孝部分将在网站移动视图中显示',
    media: '媒体',
    mobilePageCap: '移动应用程庝页面上陝',
    lGames: '游戝',
    lGameType: '游戝类型',
    typeName: '类型坝',
    gameVerticalType: '游戝垂直类型',
    haveAssignedType: '已指定类型',
    createGameType: '创建游戝类型',
    jackpotAmountOnHoverInfo: '当用户将鼠标悬停在大厅中的游戏缩略图上时，会显示大奖金额',
    jackpotAmountOnThumbnailInfo: '大奖金额显示在游戏缩略图中',
    visibleInGamesSeoPage: '在游戏的SEO页面中可见',
    providerViewingType: '提供商查看类型',
    providerLogo: '提供商徽标',
    widgetIcon: '小工具图标',
    widgetContentType: '内容类型',
    desktopBackground: '桌面背景',
    mobileBackground: '移动背景',
    gameMainSettings: '游戏主设置',
    imageGridType: '图像网格类型',
    small: '小',
    row: '行',
    gameCap: 'Game Cap',
    gameSelection: '游戏选择',
    lobbyHome: '大厅主页',
    lobbyHomeHint: '指定大厅的静态基于小工具“大厅主页”页面的可用性。',
    navigationBar: '导航栏',
    navigationBarHint: '指定主大厅和“大厅主页”页面的导航栏的可用性。',
    isSmallImageSizeInfo: '如果选择“小”，则网站上的图像尺寸将更改为较小的尺寸。',
    widgetVisibilityInfo: '该小工具仅对登录的玩家可见',
    wins: '赢',
    winType: '赢类型',
    groupSelection: '组选择',
    viewingType: '查看类型',
    group: '组',
    items: '项目',
    groupViewingType: '组查看类型',
    uploadProviderInfo: '您可以上传提供商列表。只接受CSV格式',
    randomGamesWidgetInfo: '所选游戏将被保存并随机用于小工具。',
    widgetImage: '小工具图片',
    widgetBackground: '小工具背景',
    desktopImage: '桌面图像',
    mobileImage: '移动图像',
    providerAndGamesSelection: '提供商和游戏选择',
    searchPopup: '搜索弹出窗口',
    visibleInSearchPopUp: '在搜索弹出窗口中可见',
    jackpotSet: '大奖套装',
    gameUpload: '游戏上传',
    parallaxInfo: '如果激活了视差解决方案，则应激活四种媒体',
    parallax: '视差',
    manageCollection: '管理收集',
    cap: 'Cap',
    uploadImage: '上传图像',
    viewImage: '查看图像',
    image: '图像',
    gameDetailsOnHover: '悬停在游戏详情上',
    gameDetailsOnHoverInfo: '允许配置悬停时显示的游戏信息',
    bannerSet: '横幅集',
    storySet: '故事集',
    depositButtonOnGames: '游戏中的存款按钮',
    depositButtonOnGamesHint: '激活后，移动视图上的游戏将带有存款按钮。如果游戏为演示版，演示按钮将默认隐藏。',
    mobileOrder: '移动订单',
    desktopOrder: '桌面订单',
    countdownWidget: '倒计时小组件',
    gameWidgetGameCountInfo: '仅前 {{count}} 个活跃游戏将包含在组件中',
    gameGroupSegmentGamesInfo: '游戏分组变更不会影响已创建实体',
    gameGroupGameCountInfo: '仅前 {{count}} 个活跃游戏将包含在分组中',
    demoButtonOnGames: '游戏演示按钮',
    demoButtonOnGamesInfo: '仅当“演示启动”和“演示按钮”均启用时才显示',
    groupList: '分组列表',
    groupListNote: '启用后，该分组将在网站显示',
    zingBrainInfo: 'ZingBrain 推荐游戏',
    recommendationType: '推荐类型',
    dynamicOrder: '动态排序',
  },
  ro: {
    cashier: 'Casier',
    paymentLogo: 'Sigla sistemului de plată',
    methodName: 'Numele de metodă',
    pgState: 'Stare de sistem de plată',
    platformState: 'Starea de platformă',
    allowedActivities: 'Acțiuni permise',
    supportedCountries: 'Țări disponibile',
    depositSupportedCurrencies: 'Valute pentru depozit',
    withdrawalSupportedCurrencies: 'Valute valutare disponibile pentru retragere',
    showForTags: 'Afișează pentru etichete',
    hideForTags: 'Ascunde pentru etichete',
    depositProcessingPeriod: 'Perioadă de procesare a depunerii',
    withdrawalProcessingPeriod: 'Perioadă de procesare a retragerii',
    processingPeriod: 'Perioadă de procesare',
    info: 'Informație',
    showInfoForDeposit: 'Afișează informații despre depozite',
    showInfoForWithdrawal: 'Afișează informații pentru retragere',
    processingRange: 'Interval de timp pentru procesare ',
    categoryName: 'Numele de categorie',
    lCategory: 'categorie',
    translationKeyInfo: 'Asigură-te că adaugi traduceri pentru cheie, pentru ca numele specifice limbii să fie afișate pe site-ul web',
    deleteCategoryInfo: 'Toate metodele de plată a categoriei vor fi mutate în categoria de Alte sisteme',
    cashierDeposit: 'Depunere de fonduri în casierie',
    cashierWithdrawal: 'Retragere prin casierie',
    depositState: 'Starea de depozit',
    withdrawalState: 'Starea de retagere',
    generalComponentsInfo: 'Componentele comune sunt marcate cu',
    lSymbol: 'simbol',
    resetTranslationsInfo: 'Resetarea va șterge toate traducerile personalizate din secțiunea curentă.',
    exportTranslationInfo: 'Vor fi incluse cheile de traducere',
    defaultTranslation: 'Traducere implicită',
    defaultTranslationInfo: 'Se vor utiliza traducerile din această coloană, atunci când traducerea personalizată va fi eliminată',
    addHintLanguage: 'Adaugă limbajul indicativ',
    selectHintsLanguage: 'Selectează limba de sugestii',
    deleteHintLanguage: 'Șterge limba de sugestii',
    section: 'Secțiune',
    chooseLanguage: 'Alege limba',
    availableTranslationsBySections: 'Traduceri disponibile după secțiuni',
    key: 'Cheie',
    availableTranslations: 'Traduceri disponibile',
    createFolder: 'Crează fișier',
    moveTo: 'Mută la',
    makeSureFileIsNotUsedInfo: 'Asigură-te că acest fișier nu este întrebuinţat altundeva.',
    makeSureFilesAreNotUsedInfo: 'Asigură-te că aceste fișiere nu sunt întrebuinţate altundeva.',
    folderName: 'Numele de dosar',
    filesUrlsChangedInfo: 'Adresele URL ale fișierelor vor fi schimbate.',
    searchFolder: 'Căuta folderul',
    move: 'Muta',
    folders: 'Foldere',
    rename: 'Renumi',
    folderFilesDeletedInfo: 'Fișierele din folder vor fi și ele șterse.',
    totalSize: 'Mărimea totală',
    contains: 'Conține',
    file: 'Fișier',
    lFile: 'fișier',
    lFiles: 'fișiere',
    theFile: 'Fișierul',
    files: 'Fișiere',
    lFolder: 'fișier',
    folder: 'Fișier',
    lFolders: 'fișiere',
    fileName: 'Nume de fișier',
    dropHereOrUseUploadButton: '<0>Plasează fișierele aici</0><1> sau folosește butonul Încărcare.</1>',
    copyUrl: 'Copia adresa URL',
    extension: 'Extensie',
    size: 'Mărime',
    dimensions: 'Dimensiuni',
    url: 'URL',
    droppedFileInfo: 'Fișierele plasate vor fi încărcate imediat în acest folder',
    theTranslation: 'Traducerea',
    lSection: 'secțiune',
    thePaymentMethod: 'Metoda de plată',
    theCategory: 'Categorie',
    cashierSettings: 'Setări de plată/casierie',
    fileOrFiles: 'Fișiere',
    showingUpdates: 'Afișare a actualizărilor pe site poate dura până la 30 de secunde.',
    inputLanguageKeyHere: '{{languageName}}: Introduce aici',
    subCategory: 'Subcategorie',
    themes: 'Teme',
    systemState: 'Stare de sistem',
    maintenanceState: 'Stare de mentenanță',
    maintenanceDates: 'Date de mentenanță',
    newTill: 'Nou până la',
    fixedTill: 'Fixat până la',
    promoTill: 'Promoție până la',
    dateTill: 'Data până la',
    newGame: 'Un joc nou',
    fixedGame: 'Joc fixat',
    promoGame: 'Joc promoțional',
    minLimit: 'Limită minimă',
    maxLimit: 'Limită maximă',
    isCustom: 'Este personalizat',
    standard: 'Standart',
    vertical: 'Vertical',
    horizontal: 'Orizontală',
    background: 'Fundal',
    maintenanceDate: 'Data de mentenanță',
    lGame: 'Joc',
    infinity: 'Infinit',
    new: 'Nou',
    isNew: 'Este nou',
    fixed: 'Fix',
    isFixed: 'Este fix',
    promo: 'Promo',
    isPromo: 'Este promo',
    gameSettings: 'Setări de joc',
    maintenance: 'Mentenanță',
    gameGroup: 'Grup de joc',
    orderBy: 'Comanda de',
    createGroup: 'Crează un grup',
    lGroup: 'grup',
    set: 'Seta',
    groupType: 'Tip de grup',
    uploadListInfo: 'Poți încărca liste cu ID-uri de joc. Doar formatul CSV este acceptabil',
    thePaymentMethods: 'Metode de plată',
    gridType: 'Tip grilă',
    providersPositioning: 'Poziționarea furnizorilor, modul de plasare a furnizorilor',
    groups: 'Grupuri',
    gameDetailsPreviewInfo: 'Detaliile jocului sunt afișate pe site-ul web împreună cu funcția previzualizare',
    gameDetailsCardInfo: 'Detaliile jocului sunt afișate pe site-ul web împreună cu Card Footer',
    providerGamesCount: 'Numărul furnizorilor de jocuri',
    secondaryOrdering: 'Comandă secundară',
    advancedView: 'Vizualizare avansată',
    lobbyProviders: 'Furnizori de lobby',
    providerOrder: 'Ordine furnizor',
    gameOrder: 'Ordine joc',
    secondaryOrderingNote:
      '„Ordonarea secundară a jocurilor” funcționează când configurația este activă și este selectat un singur furnizor. Pentru celelalte situații se aplică ordonarea în funcție de grup.',
    providerOrderingNote: 'În mod implicit sau când nu este bifată, se stabilește ordonarea alfabetică a furnizorilor. Când este bifată, se aplică ordonarea personalizată',
    searchId: 'Căutare ID',
    uploadGames: 'Încărcare jocuri',
    providerOrdering: 'Ordonare furnizori',
    pageCap: 'Limită pagină',
    playerSpecificGamesAllowed: 'Se permit jocuri specifice jucătorului',
    loggedInOnly: 'Doar conectat',
    visibleInMyCasino: 'Vizibil în Cazinoul meu',
    visibleOnGameView: 'Vizibil în Vizualizare joc',
    visibleOnTheLeftBarMenu: 'Vizibil în meniul din bara stângă',
    visibleOnMultiGameMenu: 'Vizibil în meniul cu jocuri multiple',
    visibleOnNavigation: 'Vizibil în navigare',
    myCasino: 'Cazinoul meu',
    gameView: 'Vizualizare joc',
    leftBarMenu: 'Meniu bara stângă',
    multiGameMenu: 'Meniu jocuri multiple',
    navigation: 'Navigare',
    lobbies: 'Lobby-uri',
    visibleOn: 'Vizibil pe',
    optional: 'Opțional',
    lobbyWidgetsJackpotInfo: 'Atenție, disponibil doar pentru fluxul Jackpot EGT',
    gameStatus: 'Stare joc',
    gamesInfoNote: 'Notă de informații privind jocurile',
    gamesInfoNoteHint: 'Butonul „Notă de informații privind jocurile” devine disponibil pe website',
    providerId: 'ID furnizor',
    gameBackground: 'Fundal joc',
    gameBackgroundHint: 'Dacă este activat, imaginile de fundal ale jocurilor devin disponibile pe website, în momentul lansării din lobby',
    myCasinoHint: 'Dacă este activată, subsecțiunea „Cazinoul meu” devine disponibilă pe website în vizualizarea pe dispozitive mobile',
    media: 'Media',
    mobilePageCap: 'Limită pagină pentru aplicații mobile',
    lGames: 'jocuri',
    lGameType: 'tip joc',
    typeName: 'Nume tip',
    gameVerticalType: 'Tip joc vertical',
    haveAssignedType: 'Tip atribuire',
    createGameType: 'Tip creare joc',
    jackpotAmountOnHoverInfo: 'Valoarea jackpotului se afișează atunci când utilizatorul trece cu cursorul peste o miniatură a jocului în lobby',
    jackpotAmountOnThumbnailInfo: 'Valoarea jackpotului se afișează în rama miniaturii de joc',
    visibleInGamesSeoPage: 'Vizibil în pagina SEO a jocurilor',
    providerViewingType: 'Tip de vizualizare furnizor',
    providerLogo: 'Sigla furnizorului',
    widgetIcon: 'Pictogramă widget',
    widgetContentType: 'Tip de conținut',
    desktopBackground: 'Fundal desktop',
    mobileBackground: 'Fundal mobil',
    gameMainSettings: 'Setări principale ale jocului',
    imageGridType: 'Tip grilă imagine',
    small: 'Mic',
    row: 'Rând',
    gameCap: 'Limită pagină',
    gameSelection: 'Selecție joc',
    lobbyHome: 'Acasă lobby',
    lobbyHomeHint: 'Indică disponibilitatea unei pagini statice „Acasă lobby” pe baza unui widget pentru lobby.',
    navigationBar: 'Bară de navigare',
    navigationBarHint: 'Indică disponibilitatea unei bare de navigare pentru paginile principale Lobby și „Acasă lobby”.',
    isSmallImageSizeInfo: 'Dacă se selectează Mic, imaginile vor căpăta dimensiuni mai mici pe site-ul web.',
    widgetVisibilityInfo: 'Widgetul va fi vizibil numai pentru jucătorii conectați',
    wins: 'Câștigă',
    winType: 'Tip câștig',
    groupSelection: 'Selecție grup',
    viewingType: 'Tip de vizualizare',
    group: 'Grup',
    items: 'Elemente',
    groupViewingType: 'Tip de vizualizare grup',
    uploadProviderInfo: 'Puteți încărca liste de furnizori. Se acceptă doar formatul CSV',
    randomGamesWidgetInfo: 'Jocurile selectate vor fi salvate și randomizate pentru widget.',
    widgetImage: 'Imagine widget',
    widgetBackground: 'Fundal widget',
    desktopImage: 'Imagine desktop',
    mobileImage: 'Imagine telefon mobil',
    providerAndGamesSelection: 'Selecție furnizori și jocuri',
    searchPopup: 'Fereastră de tip pop-up pentru căutare',
    visibleInSearchPopUp: 'Vizibil în fereastra de tip pop-up pentru căutare',
    jackpotSet: 'Jackpot stabilit',
    gameUpload: 'Încărcare joc',
    parallaxInfo: 'Dacă soluția paralaxă este activată, cele patru medii trebuie să fie activate',
    parallax: 'Paralaxă',
    manageCollection: 'Gestionare colecție',
    cap: 'Limită',
    uploadImage: 'Încărcare imagine',
    viewImage: 'Vizualizare imagine',
    image: 'Imagine',
    gameDetailsOnHover: 'Afișare detalii joc la trecerea cursorului pe deasupra',
    gameDetailsOnHoverInfo: 'Permite configurarea afișării informațiilor despre joc la trecerea cursorului pe deasupra',
    bannerSet: 'Banner stabilit',
    storySet: 'Story stabilit',
    depositButtonOnGames: 'Buton de depunere la jocuri',
    depositButtonOnGamesHint:
      'Când este activat, jocurile din vizualizarea pe dispozitive mobile vor avea un buton de depunere. În cazul jocurilor cu versiune demo, butonul Demo va fi ascuns în mod implicit',
    mobileOrder: 'Comandă dispozitiv mobil',
    desktopOrder: 'Comandă desktop',
    countdownWidget: 'Widget de numărătoare inversă',
    gameWidgetGameCountInfo: 'În widget vor fi incluse doar primele {{count}} jocuri active',
    gameGroupSegmentGamesInfo: 'Modificările din segmentul de joc nu vor afecta entitatea deja creată',
    gameGroupGameCountInfo: 'În grup vor fi incluse doar primele {{count}} jocuri active',
    demoButtonOnGames: 'Butonul „Demo” din jocuri',
    demoButtonOnGamesInfo: 'Butonul „Demo” apare numai dacă setările „Lansare demo” și „Buton demo” sunt activate pentru dispozitiv',
    groupList: 'Lista grupurilor',
    groupListNote: 'Dacă această setare este activă, grupul va fi vizibil pe site-ul web',
    zingBrainInfo: 'Oferă jocuri recomandate de ZingBrain',
    recommendationType: 'Tip de recomandare',
    dynamicOrder: 'Comandă dinamică',
  },
  bg: {},
  el: {
    cashier: 'Ταμείο',
    paymentLogo: 'Λογότυπο πληρωμής',
    methodName: 'Όνομα μεθόδου',
    pgState: 'Κατάσταση PG',
    platformState: 'Κατάσταση πλατφόρμας',
    allowedActivities: 'Επιτρεπόμενες δραστηριότητες',
    supportedCountries: 'Υποστηριζόμενες χώρες',
    depositSupportedCurrencies: 'Υποστηριζόμενα νομίσματα κατάθεσης',
    withdrawalSupportedCurrencies: 'Υποστηριζόμενα νομίσματα ανάληψης',
    showForTags: 'Εμφάνιση για ετικέτες',
    hideForTags: 'Απόκρυψη για ετικέτες',
    depositProcessingPeriod: 'Περίοδος επεξεργασίας κατάθεσης',
    withdrawalProcessingPeriod: 'Περίοδος επεξεργασίας ανάληψης',
    processingPeriod: 'Περίοδος επεξεργασίας',
    info: 'Πληροφορίες',
    showInfoForDeposit: 'Εμφάνιση πληροφοριών για κατάθεση',
    showInfoForWithdrawal: 'Εμφάνιση πληροφοριών για ανάληψη',
    processingRange: 'Εύρος επεξεργασίας',
    categoryName: 'Όνομα κατηγορίας',
    lCategory: 'κατηγορία',
    translationKeyInfo: 'Βεβαιωθείτε ότι προσθέσατε μεταφράσεις για το κλειδί, ώστε τα ονόματα που είναι συγκεκριμένα για τη γλώσσα να εμφανίζονται στον ιστότοπο',
    deleteCategoryInfo: 'Όλες οι μέθοδοι πληρωμής της κατηγορίας θα μετακινηθούν στην κατηγορία συστήματος Άλλα',
    cashierDeposit: 'Κατάθεση στο ταμείο',
    cashierWithdrawal: 'Ανάληψη από ταμείο',
    depositState: 'Κατάσταση κατάθεσης',
    withdrawalState: 'Κατάσταση ανάληψης',
    generalComponentsInfo: 'Τα Γενικά συστατικά επισημαίνονται με',
    lSymbol: 'σύμβολο',
    resetTranslationsInfo: 'Αν γίνει επαναφορά, θα αφαιρεθούν όλες οι προσαρμοσμένες μεταφράσεις της τρέχουσας ενότητας.',
    exportTranslationInfo: 'Θα συμπεριληφθούν κλειδιά μετάφρασης',
    defaultTranslation: 'Προεπιλεγμένη μετάφραση',
    defaultTranslationInfo: 'Οι μεταφράσεις αυτής της στήλης θα εφαρμόζονται όταν αφαιρείται η προσαρμοσμένη μετάφραση',
    addHintLanguage: 'Προσθήκη γλώσσας στοιχείου',
    selectHintsLanguage: 'Επιλογή γλώσσας στοιχείων',
    deleteHintLanguage: 'Διαγραφή γλώσσας στοιχείου',
    section: 'Ενότητα',
    chooseLanguage: 'Επιλογή γλώσσας',
    availableTranslationsBySections: 'Διαθέσιμες μεταφράσεις ανά ενότητες',
    key: 'Κλειδί',
    availableTranslations: 'Διαθέσιμες μεταφράσεις',
    createFolder: 'Δημιουργία φακέλου',
    moveTo: 'Μετακίνηση σε',
    makeSureFileIsNotUsedInfo: 'Βεβαιωθείτε ότι αυτό το αρχείο δεν χρησιμοποιείται αλλού.',
    makeSureFilesAreNotUsedInfo: 'Βεβαιωθείτε ότι αυτά τα αρχεία δεν χρησιμοποιούνται αλλού.',
    folderName: 'Όνομα φακέλου',
    filesUrlsChangedInfo: 'Τα URL των αρχείων θα αλλάξουν.',
    searchFolder: 'Αναζήτηση φακέλου',
    move: 'Μετακίνηση',
    folders: 'Φάκελοι',
    rename: 'Μετονομασία',
    folderFilesDeletedInfo: 'Τα αρχεία που βρίσκονται στον φάκελο θα διαγραφούν επίσης.',
    totalSize: 'Συνολικό μέγεθος',
    contains: 'Περιέχει',
    file: 'Αρχείο',
    lFile: 'αρχείο',
    lFiles: 'αρχεία',
    theFile: 'Το αρχείο',
    files: 'Αρχεία',
    lFolder: 'φάκελος',
    folder: 'Φάκελος',
    lFolders: 'φάκελοι',
    fileName: 'Όνομα αρχείου',
    dropHereOrUseUploadButton: '<0>Αποθέστε τα αρχεία εδώ</0><1> ή χρησιμοποιήστε το κουμπί Μεταφόρτωση.</1>',
    copyUrl: 'Αντιγραφή URL',
    extension: 'Επέκταση',
    size: 'Μέγεθος',
    dimensions: 'Διαστάσεις',
    url: 'URL',
    droppedFileInfo: 'Τα αρχεία που αποτέθηκαν θα μεταφορτωθούν αμέσως σε αυτόν τον φάκελο',
    theTranslation: 'Η μετάφραση',
    lSection: 'ενότητα',
    thePaymentMethod: 'Η μέθοδος πληρωμής',
    theCategory: 'Η κατηγορία',
    cashierSettings: 'Ρυθμίσεις ταμείου',
    fileOrFiles: 'Αρχείο(-α)',
    showingUpdates: 'Η εμφάνιση των ενημερώσεων στον ιστότοπο μπορεί να χρειαστεί μέχρι και 30 δευτερόλεπτα.',
    inputLanguageKeyHere: '{{languageName}}: Εισαγάγετε εδώ',
    subCategory: 'Υποκατηγορία',
    themes: 'Θέματα',
    systemState: 'Κατάσταση συστήματος',
    maintenanceState: 'Κατάσταση συντήρησης',
    maintenanceDates: 'Ημερομηνίες συντήρησης',
    newTill: 'Νέο μέχρι',
    fixedTill: 'Σταθερό μέχρι',
    promoTill: 'Προωθητική ενέργεια μέχρι',
    dateTill: 'Ημερομηνία μέχρι',
    newGame: 'Νέο παιχνίδι',
    fixedGame: 'Σταθερό παιχνίδι',
    promoGame: 'Παιχνίδι προωθητικής ενέργειας',
    minLimit: 'Ελάχιστο όριο',
    maxLimit: 'Μέγιστο όριο',
    isCustom: 'Είναι προσαρμοσμένο',
    standard: 'Βασικό',
    vertical: 'Κάθετη',
    horizontal: 'Οριζόντια',
    background: 'Φόντο',
    maintenanceDate: 'Ημερομηνία συντήρησης',
    lGame: 'παιχνίδι',
    infinity: 'Άπειρο',
    new: 'Νέο',
    isNew: 'Είναι νέο',
    fixed: 'Σταθερό',
    isFixed: 'Είναι σταθερό',
    promo: 'Προωθητική ενέργεια',
    isPromo: 'Είναι προωθητική ενέργεια',
    gameSettings: 'Ρυθμίσεις παιχνιδιού',
    maintenance: 'Συντήρηση',
    gameGroup: 'Ομάδα παιχνιδιού',
    orderBy: 'Ταξινόμηση κατά',
    createGroup: 'Δημιουργία ομάδας',
    lGroup: 'ομάδα',
    set: 'Ρύθμιση',
    groupType: 'Τύπος ομάδας',
    uploadListInfo: 'Μπορείτε να μεταφορτώσετε λίστες με Αναγνωριστικά παιχνιδιού. Μόνο η μορφή CSV είναι αποδεκτή',
    thePaymentMethods: 'Οι μέθοδοι πληρωμής',
    gridType: 'Τύπος πίνακα',
    providersPositioning: 'Τοποθέτηση παρόχων',
    groups: 'Ομάδες',
    gameDetailsPreviewInfo: 'Τα στοιχεία του παιχνιδιού εμφανίζονται στον ιστότοπο με προεπισκόπηση',
    gameDetailsCardInfo: 'Τα στοιχεία του παιχνιδιού εμφανίζονται στον ιστότοπο με Card Footer',
    providerGamesCount: 'Αριθμός παιχνιδιών παρόχου',
    secondaryOrdering: 'Δευτερεύουσα ταξινόμηση',
    advancedView: 'Προηγμένη προβολή',
    lobbyProviders: 'Πάροχοι λόμπι',
    providerOrder: 'Σειρά παρόχων',
    gameOrder: 'Σειρά παιχνιδιού',
    secondaryOrderingNote:
      'Η Δευτερεύουσα ταξινόμηση παιχνιδιού λειτουργεί όταν η διαμόρφωση είναι ενεργή και έχει επιλεγεί μόνο ένας πάροχος, σε κάθε άλλη περίπτωση εφαρμόζεται η συγκεκριμένη ταξινόμηση ομάδας.',
    providerOrderingNote: 'Είτε από προεπιλογή είτε όταν δεν είναι επιλεγμένο, η σειρά των παρόχων είναι αλφαβητική. Όταν είναι επιλεγμένο, εφαρμόζεται προσαρμοσμένη σειρά',
    searchId: 'Αναγνωριστικό αναζήτησης',
    uploadGames: 'Μεταφόρτωση παιχνιδιών',
    providerOrdering: 'Ταξινόμηση παρόχων',
    pageCap: 'Όριο σελίδας',
    playerSpecificGamesAllowed: 'Επιτρέπονται συγκεκριμένα παιχνίδια για τον παίκτη',
    loggedInOnly: 'Συνδεδεμένος μόνο',
    visibleInMyCasino: 'Εμφανίζεται στο Το Καζίνο μου',
    visibleOnGameView: 'Εμφανίζεται στην Προβολή παιχνιδιού',
    visibleOnTheLeftBarMenu: 'Εμφανίζεται στο Μενού Αριστερής μπάρας',
    visibleOnMultiGameMenu: 'Εμφανίζεται στο Μενού Πολλαπλών παιχνιδιών',
    visibleOnNavigation: 'Εμφανίζεται στην Πλοήγηση',
    myCasino: 'Το Καζίνο μου',
    gameView: 'Προβολή παιχνιδιού',
    leftBarMenu: 'Μενού Αριστερής μπάρας',
    multiGameMenu: 'Μενού Πολλαπλών παιχνιδιών',
    navigation: 'Πλοήγηση',
    lobbies: 'Λόμπι',
    visibleOn: 'Εμφανίζεται στο',
    optional: 'Προαιρετικό',
    lobbyWidgetsJackpotInfo: 'Θα πρέπει να σημειωθεί ότι είναι μόνο διαθέσιμη στην τροφοδότηση του τζάκποτ της EGT',
    gameStatus: 'Κατάσταση παιχνιδιού',
    gamesInfoNote: 'Σημείωση πληροφοριών παιχνιδιών',
    gamesInfoNoteHint: 'Το πλήκτρο Σημείωσης πληροφοριών παιχνιδιών γίνεται διαθέσιμο στον ιστότοπο',
    providerId: 'Αναγνωριστικό παρόχου',
    gameBackground: 'Φόντο παιχνιδιού',
    gameBackgroundHint: 'Αν είναι ενεργοποιημένο, οι εικόνες φόντου των παιχνιδιών γίνονται διαθέσιμες στον ιστότοπο όταν γίνεται έναρξή τους από τα λόμπι',
    myCasinoHint: 'Αν είναι ενεργοποιημένη, η υποενότητα «Το Καζίνο μου» γίνεται διαθέσιμη στην προβολή για κινητά',
    media: 'Μέσα',
    mobilePageCap: 'Όριο σελίδας για εφαρμογές για κινητά',
    lGames: 'παιχνίδια',
    lGameType: 'τύπος παιχνιδιού',
    typeName: 'Όνομα τύπου',
    gameVerticalType: 'Τύπος κάθετου παιχνιδιού',
    haveAssignedType: 'Τύπος ανάθεσης',
    createGameType: 'Τύπος δημιουργίας παιχνιδιού',
    jackpotAmountOnHoverInfo: 'Το ποσό τζάκποτ εμφανίζεται όταν ο χρήστης αφήνει τον δείκτη του ποντικιού πάνω από ένα thumbnail παιχνιδιού στο λόμπι.',
    jackpotAmountOnThumbnailInfo: 'Το ποσό του τζάκποτ εμφανίζεται μέσα στο πλαίσιο του thumbnail',
    visibleInGamesSeoPage: 'Σελίδα SEO του παιχνιδιού',
    providerViewingType: 'Τύπος προβολής παρόχου',
    providerLogo: 'Λογότυπο παρόχου',
    widgetIcon: 'Εικονίδιο γραφικού στοιχείου',
    widgetContentType: 'Τύπος περιεχομένου',
    desktopBackground: 'Φόντο υπολογιστή',
    mobileBackground: 'Φόντο κινητού',
    gameMainSettings: 'Βασικές ρυθμίσεις παιχνιδιού',
    imageGridType: 'Εικόνα τύπου πίνακα',
    small: 'Μικρό',
    row: 'Σειρά',
    gameCap: 'Όριο παιχνιδιού',
    gameSelection: 'Επιλογή παιχνιδιού',
    lobbyHome: 'Αρχική Λόμπι',
    lobbyHomeHint: 'Καθορίζει τη διαθεσιμότητα ενός στατικού γραφικού στοιχεία-Βασική «Αρχική Λόμπι» Σελίδα για το λόμπι',
    navigationBar: 'Μπάρα πλοήγησης',
    navigationBarHint: 'Καθορίζει τη διαθεσιμότητα μιας Μπάρας πλοήγησης τόσο για τη σελίδα Κεντρικό Λόμπι όσο και για τη σελίδα «Αρχική Λόμπι».',
    isSmallImageSizeInfo: 'Σε περίπτωση που επιλεγεί Μικρή, το μέγεθος των εικόνων θα αλλάζει σε μικρότερο μέγεθος στον Ιστότοπο.',
    widgetVisibilityInfo: 'Το γραφικό στοιχεία θα εμφανίζεται μόνο σε συνδεδεμένους παίκτες',
    wins: 'Κερδίζει',
    winType: 'Τύπος κέρδους',
    groupSelection: 'Επιλογή ομάδας',
    viewingType: 'Τύπος προβολής',
    group: 'Ομάδα',
    items: 'Στοιχεία',
    groupViewingType: 'Τύπος προβολής ομάδας',
    uploadProviderInfo: 'Μπορείτε να μεταφορτώσετε λίστες παρόχων. Μόνο η μορφή CSV είναι αποδεκτή',
    randomGamesWidgetInfo: 'Τα επιλεγμένα Παιχνίδια θα αποθηκεύονται και θα τυχαιοποιούνται για το γραφικό στοιχείο.',
    widgetImage: 'Εικόνα γραφικού στοιχείου',
    widgetBackground: 'Φόντο γραφικού στοιχείου',
    desktopImage: 'Εικόνα υπολογιστή',
    mobileImage: 'Εικόνα κινητού τηλεφώνου',
    providerAndGamesSelection: 'Επιλογή παρόχων και παιχνιδιών',
    searchPopup: 'Αναζήτηση αναδυόμενου παραθύρου',
    visibleInSearchPopUp: 'Εμφανίζεται στην αναζήτηση αναδυόμενου παραθύρου',
    jackpotSet: 'Σύνολο τζάκποτ',
    gameUpload: 'Μεταφόρτωση παιχνιδιού',
    parallaxInfo: 'Σε περίπτωση που είναι ενεργοποιημένη η λύση parallax, τα τέσσερα μέσα θα πρέπει να είναι ενεργοποιημένα',
    parallax: 'Parallax',
    manageCollection: 'Διαχείριση συλλογής',
    cap: 'Όριο',
    uploadImage: 'Μεταφόρτωση εικόνας',
    viewImage: 'Προβολή εικόνας',
    image: 'Εικόνα',
    gameDetailsOnHover: 'Στοιχεία παιχνιδιού όταν ο δείκτης του ποντικιού μένει πάνω',
    gameDetailsOnHoverInfo: 'Επιτρέπει να ρυθμιστεί η εμφάνιση των πληροφοριών του παιχνιδιού όταν ο δείκτης του ποντικιού μένει πάνω',
    bannerSet: 'Σύνολο μπάνερ',
    storySet: 'Σύνολο ιστοριών',
    depositButtonOnGames: 'Κουμπί κατάθεσης στα παιχνίδια',
    depositButtonOnGamesHint:
      'Όταν είναι ενεργοποιημένο, τα παιχνίδια στην προβολή για κινητά θα έχουν το Κουμπί Κατάθεσης. Σε περίπτωση που τα παιχνίδια έχουν τη δοκιμαστική έκδοση, το Δοκιμαστικό Κουμπί θα είναι κρυμμένο από προεπιλογή',
    mobileOrder: 'Παραγγελία για κινητά',
    desktopOrder: 'Παραγγελία για υπολογιστές',
    countdownWidget: 'Γραφικό στοιχείο αντίστροφης μέτρησης',
    gameWidgetGameCountInfo: 'Στο widget θα περιλαμβάνονται μόνο τα πρώτα {{count}} ενεργά παιχνίδια',
    gameGroupSegmentGamesInfo: 'Οι αλλαγές στον τομέα του παιχνιδιού δεν θα επηρεάσουν την οντότητα που έχει ήδη δημιουργηθεί',
    gameGroupGameCountInfo: 'Στην ομάδα θα περιλαμβάνονται μόνο τα πρώτα {{count}} ενεργά παιχνίδια',
    demoButtonOnGames: 'Κουμπί δοκιμαστικής έκδοσης στα παιχνίδια',
    demoButtonOnGamesInfo: 'Το κουμπί δοκιμαστικής έκδοσης εμφανίζεται μόνο αν έχουν ενεργοποιηθεί οι ρυθμίσεις για την έναρξη δοκιμαστικής έκδοσης και το κουμπί δοκιμαστικής έκδοσης για τη συσκευή',
    groupList: 'Λίστα ομάδας',
    groupListNote: 'Εάν η ρύθμιση είναι ενεργοποιημένη, η ομάδα θα είναι ορατή στον ιστότοπο',
    zingBrainInfo: 'Προσφέρει παιχνίδια που προτείνει το ZingBrain',
    recommendationType: 'Τύπος σύστασης',
    dynamicOrder: 'Δυναμική σειρά',
  },
};
